/**
 * Countries Collection.
 *
 * Contains static list of available ticket's message types, which can be used for different
 * purposes, like filling lists, allowing options selection, etc.
 */
export default [
  {
    key: 'AD',
    value: 'Andorra',
    code: {
      a2: 'AD',
      a3: 'AND',
    },
    shortList: 'x',
    houseNumber: false,
    state: false,
    parent: null,
    depType: null,
    stateTerm: null,
    currency: {
      code: 'EUR',
      name: 'Euro',
      symbol: '€',
    },
    num: 20,
    dialingCode: 376,
    langs: [
      {
        name: 'Catalan',
        code: 'ca',
      },
    ],
    tz: [
      {
        name: 'Central European Time',
        code: 'CET',
        gmtOffset: '+1',
      },
      {
        name: 'Central European Time',
        code: 'CET',
        gmtOffset: '+1',
      },
    ],
    dst: true,
  },
  {
    key: 'AE',
    value: 'United Arab Emirates',
    code: {
      a2: 'AE',
      a3: 'ARE',
    },
    shortList: 'x',
    houseNumber: false,
    state: false,
    parent: null,
    depType: null,
    stateTerm: null,
    currency: {
      code: 'AED',
      name: 'United Arab Emirates Dirham',
      symbol: 'د.إ',
    },
    num: 784,
    dialingCode: 971,
    langs: [
      {
        name: 'Arabic',
        code: 'ar',
      },
    ],
    tz: [
      {
        name: 'Gulf Standard Time',
        code: 'GST',
        gmtOffset: '+4',
      },
      {
        name: 'Gulf Standard Time',
        code: 'GST',
        gmtOffset: '+4',
      },
    ],
    dst: false,
  },
  {
    key: 'AF',
    value: 'Afghanistan',
    code: {
      a2: 'AF',
      a3: 'AFG',
    },
    shortList: 'x',
    houseNumber: false,
    state: false,
    parent: null,
    depType: null,
    stateTerm: null,
    currency: {
      code: 'AFN',
      name: 'Afghani',
      symbol: '؋',
    },
    num: 4,
    dialingCode: 93,
    langs: [
      {
        name: 'Dari',
        code: 'fa',
      },
      {
        name: 'Pashto',
        code: 'ps',
      },
    ],
    tz: [
      {
        name: 'Afghanistan Time',
        code: 'AFT',
        gmtOffset: '+4:30',
      },
      {
        name: 'Afghanistan Time',
        code: 'AFT',
        gmtOffset: '+4:30',
      },
    ],
    dst: false,
  },
  {
    key: 'AG',
    value: 'Antigua and Barbuda',
    code: {
      a2: 'AG',
      a3: 'ATG',
    },
    shortList: 'x',
    houseNumber: false,
    state: false,
    parent: null,
    depType: null,
    stateTerm: null,
    currency: {
      code: 'XCD',
      name: 'East Caribbean Dollar',
      symbol: '$',
    },
    num: 28,
    dialingCode: '1-268',
    langs: [
      {
        name: 'English',
        code: 'en',
      },
    ],
    tz: [
      {
        name: 'Atlantic Standard Time',
        code: 'AST',
        gmtOffset: -4,
      },
      {
        name: 'Atlantic Standard Time',
        code: 'AST',
        gmtOffset: -4,
      },
    ],
    dst: false,
  },
  {
    key: 'AI',
    value: 'Anguilla',
    code: {
      a2: 'AI',
      a3: 'AIA',
    },
    shortList: null,
    houseNumber: false,
    state: false,
    parent: 'GB',
    depType: 'dependent',
    stateTerm: null,
    currency: {
      code: 'XCD',
      name: 'East Caribbean Dollar',
      symbol: '$',
    },
    num: 660,
    dialingCode: '1-264',
    langs: [
      {
        name: 'English',
        code: 'en',
      },
    ],
    tz: [
      {
        name: 'Atlantic Standard Time',
        code: 'AST',
        gmtOffset: -4,
      },
      {
        name: 'Atlantic Standard Time',
        code: 'AST',
        gmtOffset: -4,
      },
    ],
    dst: false,
  },
  {
    key: 'AL',
    value: 'Albania',
    code: {
      a2: 'AL',
      a3: 'ALB',
    },
    shortList: 'x',
    houseNumber: false,
    state: false,
    parent: null,
    depType: null,
    stateTerm: null,
    currency: {
      code: 'ALL',
      name: 'Lek',
      symbol: 'L',
    },
    num: 8,
    dialingCode: 355,
    langs: [
      {
        name: 'Albanian',
        code: 'sq',
      },
    ],
    tz: [
      {
        name: 'Central European Time',
        code: 'CET',
        gmtOffset: '+1',
      },
      {
        name: 'Central European Time',
        code: 'CET',
        gmtOffset: '+1',
      },
    ],
    dst: true,
  },
  {
    key: 'AM',
    value: 'Armenia',
    code: {
      a2: 'AM',
      a3: 'ARM',
    },
    shortList: 'x',
    houseNumber: false,
    state: false,
    parent: null,
    depType: null,
    stateTerm: null,
    currency: {
      code: 'AMD',
      name: 'Dram',
      symbol: '֏',
    },
    num: 51,
    dialingCode: 374,
    langs: [
      {
        name: 'Armenian',
        code: 'hy',
      },
    ],
    tz: [
      {
        name: 'Armenia Time',
        code: 'AMT',
        gmtOffset: '+4',
      },
      {
        name: 'Armenia Time',
        code: 'AMT',
        gmtOffset: '+4',
      },
    ],
    dst: false,
  },
  {
    key: 'AO',
    value: 'Angola',
    code: {
      a2: 'AO',
      a3: 'AGO',
    },
    shortList: 'x',
    houseNumber: false,
    state: false,
    parent: null,
    depType: null,
    stateTerm: null,
    currency: {
      code: 'AOA',
      name: 'Kwanza',
      symbol: 'Kz',
    },
    num: 24,
    dialingCode: 244,
    langs: [
      {
        name: 'Portuguese',
        code: 'pt',
      },
    ],
    tz: [
      {
        name: 'West Africa Time',
        code: 'WAT',
        gmtOffset: '+1',
      },
      {
        name: 'West Africa Time',
        code: 'WAT',
        gmtOffset: '+1',
      },
    ],
    dst: false,
  },
  {
    key: 'AQ',
    value: 'Antarctica',
    code: {
      a2: 'AQ',
      a3: 'ATA',
    },
    shortList: null,
    houseNumber: false,
    state: false,
    parent: null,
    depType: 'continent',
    stateTerm: null,
    currency: {
      code: null,
      name: null,
      symbol: null,
    },
    num: 10,
    dialingCode: 672,
    langs: [],
    tz: [],
    dst: null,
  },
  {
    key: 'AR',
    value: 'Argentina',
    code: {
      a2: 'AR',
      a3: 'ARG',
    },
    shortList: 'x',
    houseNumber: false,
    state: true,
    parent: null,
    depType: null,
    stateTerm: 'province',
    currency: {
      code: 'ARS',
      name: 'Argentine Peso',
      symbol: '$',
    },
    num: 32,
    dialingCode: 54,
    langs: [
      {
        name: 'Spanish',
        code: 'es',
      },
    ],
    tz: [
      {
        name: 'Argentina Time',
        code: 'ART',
        gmtOffset: -3,
      },
      {
        name: 'Argentina Time',
        code: 'ART',
        gmtOffset: -3,
      },
    ],
    dst: false,
  },
  {
    key: 'AS',
    value: 'American Samoa',
    code: {
      a2: 'AS',
      a3: 'ASM',
    },
    shortList: null,
    houseNumber: false,
    state: false,
    parent: 'US',
    depType: 'dependent',
    stateTerm: null,
    currency: {
      code: 'USD',
      name: 'US Dollar',
      symbol: '$',
    },
    num: 16,
    dialingCode: '1-684',
    langs: [
      {
        name: 'Samoan',
        code: 'sm',
      },
      {
        name: 'English',
        code: 'en',
      },
    ],
    tz: [
      {
        name: 'Samoa Standard Time',
        code: 'SST',
        gmtOffset: -11,
      },
      {
        name: 'Samoa Standard Time',
        code: 'SST',
        gmtOffset: -11,
      },
    ],
    dst: false,
  },
  {
    key: 'AT',
    value: 'Austria',
    code: {
      a2: 'AT',
      a3: 'AUT',
    },
    shortList: 'x',
    houseNumber: true,
    parent: null,
    depType: null,
    stateTerm: null,
    currency: {
      code: 'EUR',
      name: 'Euro',
      symbol: '€',
    },
    num: 40,
    dialingCode: 43,
    langs: [
      {
        name: 'German',
        code: 'de',
      },
    ],
    tz: [
      {
        name: 'Central European Time',
        code: 'CET',
        gmtOffset: '+1',
      },
      {
        name: 'Central European Time',
        code: 'CET',
        gmtOffset: '+1',
      },
    ],
    dst: true,
  },
  {
    key: 'AU',
    value: 'Australia',
    code: {
      a2: 'AU',
      a3: 'AUS',
    },
    shortList: 'x',
    houseNumber: false,
    state: true,
    parent: null,
    depType: null,
    stateTerm: 'stateProvince',
    currency: {
      code: 'AUD',
      name: 'Australian Dollar',
      symbol: '$',
    },
    num: 36,
    dialingCode: 61,
    langs: [
      {
        name: 'English',
        code: 'en',
      },
    ],
    tz: [
      {
        name: 'Australian Western Standard Time',
        code: 'AWST',
        gmtOffset: '+8',
      },
      {
        name: 'Australian Eastern Standard Time',
        code: 'AEST',
        gmtOffset: '+10',
      },
    ],
    dst: true,
  },
  {
    key: 'AW',
    value: 'Aruba',
    code: {
      a2: 'AW',
      a3: 'ABW',
    },
    shortList: null,
    houseNumber: false,
    state: false,
    parent: 'NL',
    depType: 'dependent',
    stateTerm: null,
    currency: {
      code: 'AWG',
      name: 'Aruban Florin',
      symbol: 'ƒ',
    },
    num: 533,
    dialingCode: 297,
    langs: [
      {
        name: 'Papiamento',
        code: 'pap',
      },
      {
        name: 'Dutch',
        code: 'nl',
      },
    ],
    tz: [
      {
        name: 'Atlantic Standard Time',
        code: 'AST',
        gmtOffset: -4,
      },
      {
        name: 'Atlantic Standard Time',
        code: 'AST',
        gmtOffset: -4,
      },
    ],
    dst: false,
  },
  {
    key: 'AZ',
    value: 'Azerbaijan',
    code: {
      a2: 'AZ',
      a3: 'AZE',
    },
    shortList: 'x',
    houseNumber: false,
    state: false,
    parent: null,
    depType: null,
    stateTerm: null,
    currency: {
      code: 'AZN',
      name: 'Azerbaijani Manat',
      symbol: '₼',
    },
    num: 31,
    dialingCode: 994,
    langs: [
      {
        name: 'Azerbaijani',
        code: 'az',
      },
    ],
    tz: [
      {
        name: 'Azerbaijan Time',
        code: 'AZT',
        gmtOffset: '+4',
      },
      {
        name: 'Azerbaijan Time',
        code: 'AZT',
        gmtOffset: '+4',
      },
    ],
    dst: false,
  },
  {
    key: 'BA',
    value: 'Bosnia and Herzegovina',
    code: {
      a2: 'BA',
      a3: 'BIH',
    },
    shortList: 'x',
    houseNumber: false,
    state: false,
    parent: null,
    depType: null,
    stateTerm: null,
    currency: {
      code: 'BAM',
      name: 'Convertible Mark',
      symbol: 'KM',
    },
    num: 70,
    dialingCode: 387,
    langs: [
      {
        name: 'Bosnian',
        code: 'bs',
      },
      {
        name: 'Croatian',
        code: 'hr',
      },
      {
        name: 'Serbian',
        code: 'sr',
      },
    ],
    tz: [
      {
        name: 'Central European Time',
        code: 'CET',
        gmtOffset: '+1',
      },
      {
        name: 'Central European Time',
        code: 'CET',
        gmtOffset: '+1',
      },
    ],
    dst: true,
  },
  {
    key: 'BB',
    value: 'Barbados',
    code: {
      a2: 'BB',
      a3: 'BRB',
    },
    shortList: 'x',
    houseNumber: false,
    state: false,
    parent: null,
    depType: null,
    stateTerm: null,
    currency: {
      code: 'BBD',
      name: 'Barbados Dollar',
      symbol: '$',
    },
    num: 52,
    dialingCode: '1-246',
    langs: [
      {
        name: 'English',
        code: 'en',
      },
    ],
    tz: [
      {
        name: 'Atlantic Standard Time',
        code: 'AST',
        gmtOffset: -4,
      },
      {
        name: 'Atlantic Standard Time',
        code: 'AST',
        gmtOffset: -4,
      },
    ],
    dst: false,
  },
  {
    key: 'BD',
    value: 'Bangladesh',
    code: {
      a2: 'BD',
      a3: 'BGD',
    },
    shortList: 'x',
    houseNumber: false,
    state: false,
    parent: null,
    depType: null,
    stateTerm: null,
    currency: {
      code: 'BDT',
      name: 'Bangladeshi Taka',
      symbol: '৳',
    },
    num: 50,
    dialingCode: 880,
    langs: [
      {
        name: 'Bengali',
        code: 'bn',
      },
    ],
    tz: [
      {
        name: 'Bangladesh Standard Time',
        code: 'BST',
        gmtOffset: '+6',
      },
      {
        name: 'Bangladesh Standard Time',
        code: 'BST',
        gmtOffset: '+6',
      },
    ],
    dst: false,
  },
  {
    key: 'BE',
    value: 'Belgium',
    code: {
      a2: 'BE',
      a3: 'BEL',
    },
    shortList: 'x',
    houseNumber: true,
    parent: null,
    depType: null,
    stateTerm: null,
    currency: {
      code: 'EUR',
      name: 'Euro',
      symbol: '€',
    },
    num: 56,
    dialingCode: 32,
    langs: [
      {
        name: 'Dutch',
        code: 'nl',
      },
      {
        name: 'French',
        code: 'fr',
      },
      {
        name: 'German',
        code: 'de',
      },
    ],
    tz: [
      {
        name: 'Central European Time',
        code: 'CET',
        gmtOffset: '+1',
      },
      {
        name: 'Central European Time',
        code: 'CET',
        gmtOffset: '+1',
      },
    ],
    dst: true,
  },
  {
    key: 'BF',
    value: 'Burkina Faso',
    code: {
      a2: 'BF',
      a3: 'BFA',
    },
    shortList: 'x',
    houseNumber: false,
    state: false,
    parent: null,
    depType: null,
    stateTerm: null,
    currency: {
      code: 'XOF',
      name: 'West African CFA franc',
      symbol: 'CFA',
    },
    num: 854,
    dialingCode: 226,
    langs: [
      {
        name: 'French',
        code: 'fr',
      },
    ],
    tz: [
      {
        name: 'Greenwich Mean Time',
        code: 'GMT',
        gmtOffset: '+0',
      },
      {
        name: 'Greenwich Mean Time',
        code: 'GMT',
        gmtOffset: '+0',
      },
    ],
    dst: false,
  },
  {
    key: 'BG',
    value: 'Bulgaria',
    code: {
      a2: 'BG',
      a3: 'BGR',
    },
    shortList: 'x',
    houseNumber: false,
    state: false,
    parent: null,
    depType: null,
    stateTerm: null,
    currency: {
      code: 'BGN',
      name: 'Bulgarian Lev',
      symbol: 'лв',
    },
    num: 100,
    dialingCode: 359,
    langs: [
      {
        name: 'Bulgarian',
        code: 'bg',
      },
    ],
    tz: [
      {
        name: 'Eastern European Time',
        code: 'EET',
        gmtOffset: '+2',
      },
      {
        name: 'Eastern European Time',
        code: 'EET',
        gmtOffset: '+2',
      },
    ],
    dst: true,
  },
  {
    key: 'BH',
    value: 'Bahrain',
    code: {
      a2: 'BH',
      a3: 'BHR',
    },
    shortList: 'x',
    houseNumber: false,
    state: false,
    parent: null,
    depType: null,
    stateTerm: null,
    currency: {
      code: 'BHD',
      name: 'Bahraini Dinar',
      symbol: '?.د.ب',
    },
    num: 48,
    dialingCode: 973,
    langs: [
      {
        name: 'Arabic',
        code: 'ar',
      },
    ],
    tz: [
      {
        name: 'Arabian Standard Time',
        code: 'AST',
        gmtOffset: '+3',
      },
      {
        name: 'Arabian Standard Time',
        code: 'AST',
        gmtOffset: '+3',
      },
    ],
    dst: false,
  },
  {
    key: 'BI',
    value: 'Burundi',
    code: {
      a2: 'BI',
      a3: 'BDI',
    },
    shortList: 'x',
    houseNumber: false,
    state: false,
    parent: null,
    depType: null,
    stateTerm: null,
    currency: {
      code: 'BIF',
      name: 'Burundi Franc',
      symbol: null,
    },
    num: 108,
    dialingCode: 257,
    langs: [
      {
        name: 'Kirundi',
        code: 'rn',
      },
      {
        name: 'French',
        code: 'fr',
      },
      {
        name: 'English',
        code: 'en',
      },
    ],
    tz: [
      {
        name: 'Central Africa Time',
        code: 'CAT',
        gmtOffset: '+2',
      },
      {
        name: 'Central Africa Time',
        code: 'CAT',
        gmtOffset: '+2',
      },
    ],
    dst: false,
  },
  {
    key: 'BJ',
    value: 'Benin',
    code: {
      a2: 'BJ',
      a3: 'BEN',
    },
    shortList: 'x',
    houseNumber: false,
    state: false,
    parent: null,
    depType: null,
    stateTerm: null,
    currency: {
      code: 'XOF',
      name: 'West African CFA franc',
      symbol: null,
    },
    num: 204,
    dialingCode: 229,
    langs: [
      {
        name: 'French',
        code: 'fr',
      },
    ],
    tz: [
      {
        name: 'West Africa Time',
        code: 'WAT',
        gmtOffset: '+1',
      },
      {
        name: 'West Africa Time',
        code: 'WAT',
        gmtOffset: '+1',
      },
    ],
    dst: false,
  },
  {
    key: 'BL',
    value: 'Saint Barthelemy',
    code: {
      a2: 'BL',
      a3: 'BLM',
    },
    shortList: null,
    houseNumber: false,
    state: false,
    parent: 'FR',
    depType: 'dependent',
    stateTerm: null,
    currency: {
      code: 'EUR',
      name: 'Euro',
      symbol: '€',
    },
    num: 652,
    dialingCode: 590,
    langs: [
      {
        name: 'French',
        code: 'fr',
      },
    ],
    tz: [
      {
        name: 'Atlantic Standard Time',
        code: 'AST',
        gmtOffset: -4,
      },
      {
        name: 'Atlantic Standard Time',
        code: 'AST',
        gmtOffset: -4,
      },
    ],
    dst: false,
  },
  {
    key: 'BM',
    value: 'Bermuda',
    code: {
      a2: 'BM',
      a3: 'BMU',
    },
    shortList: null,
    houseNumber: false,
    state: false,
    parent: 'GB',
    depType: 'dependent',
    stateTerm: null,
    currency: {
      code: 'BMD',
      name: 'Bermudian Dollar',
      symbol: '$',
    },
    num: 60,
    dialingCode: '1-441',
    langs: [
      {
        name: 'English',
        code: 'en',
      },
    ],
    tz: [
      {
        name: 'Atlantic Standard Time',
        code: 'AST',
        gmtOffset: -4,
      },
      {
        name: 'Atlantic Standard Time',
        code: 'AST',
        gmtOffset: -4,
      },
    ],
    dst: true,
  },
  {
    key: 'BN',
    value: 'Brunei Darussalam',
    code: {
      a2: 'BN',
      a3: 'BRN',
    },
    shortList: 'x',
    houseNumber: false,
    state: false,
    parent: null,
    depType: null,
    stateTerm: null,
    currency: {
      code: 'BND',
      name: 'Brunei Dollar',
      symbol: '$',
    },
    num: 96,
    dialingCode: 673,
    langs: [
      {
        name: 'Malay',
        code: 'ms',
      },
    ],
    tz: [
      {
        name: 'Brunei Time',
        code: 'BNT',
        gmtOffset: '+8',
      },
      {
        name: 'Brunei Time',
        code: 'BNT',
        gmtOffset: '+8',
      },
    ],
    dst: false,
  },
  {
    key: 'BO',
    value: 'Bolivia',
    code: {
      a2: 'BO',
      a3: 'BOL',
    },
    shortList: 'x',
    houseNumber: false,
    state: false,
    parent: null,
    depType: null,
    stateTerm: null,
    currency: {
      code: 'BOB',
      name: 'Boliviano',
      symbol: 'Bs',
    },
    num: 68,
    dialingCode: 591,
    langs: [
      {
        name: 'Spanish',
        code: 'es',
      },
      {
        name: 'Quechua',
        code: 'qu',
      },
      {
        name: 'Aymara',
        code: 'ay',
      },
    ],
    tz: [
      {
        name: 'Bolivia Time',
        code: 'BOT',
        gmtOffset: -4,
      },
      {
        name: 'Bolivia Time',
        code: 'BOT',
        gmtOffset: -4,
      },
    ],
    dst: false,
  },
  {
    key: 'BQ',
    value: 'Bonaire',
    code: {
      a2: 'BQ',
      a3: 'BES',
    },
    shortList: null,
    houseNumber: false,
    state: false,
    parent: 'NL',
    depType: 'dependent',
    stateTerm: null,
    currency: {
      code: 'USD',
      name: 'US Dollar',
      symbol: '$',
    },
    num: 535,
    dialingCode: 599,
    langs: [
      {
        name: 'Dutch',
        code: 'nl',
      },
    ],
    tz: [
      {
        name: 'Atlantic Standard Time',
        code: 'AST',
        gmtOffset: -4,
      },
      {
        name: 'Atlantic Standard Time',
        code: 'AST',
        gmtOffset: -4,
      },
    ],
    dst: false,
  },
  {
    key: 'BR',
    value: 'Brazil',
    code: {
      a2: 'BR',
      a3: 'BRA',
    },
    shortList: 'x',
    houseNumber: false,
    state: true,
    parent: null,
    depType: null,
    stateTerm: 'stateProvince',
    currency: {
      code: 'BRL',
      name: 'Brazilian Real',
      symbol: 'R$',
    },
    num: 76,
    dialingCode: 55,
    langs: [
      {
        name: 'Portuguese',
        code: 'pt',
      },
    ],
    tz: [
      {
        name: 'Amazon Time',
        code: 'AMT',
        gmtOffset: -5,
      },
      {
        name: 'Fernando de Noronha Time',
        code: 'FNT',
        gmtOffset: -2,
      },
    ],
    dst: false,
  },
  {
    key: 'BS',
    value: 'Bahamas',
    code: {
      a2: 'BS',
      a3: 'BHS',
    },
    shortList: 'x',
    houseNumber: false,
    state: false,
    parent: null,
    depType: null,
    stateTerm: null,
    currency: {
      code: 'BSD',
      name: 'Bahamian Dollar',
      symbol: '$',
    },
    num: 44,
    dialingCode: '1-242',
    langs: [
      {
        name: 'English',
        code: 'en',
      },
    ],
    tz: [
      {
        name: 'Eastern Standard Time',
        code: 'EST',
        gmtOffset: -5,
      },
      {
        name: 'Eastern Standard Time',
        code: 'EST',
        gmtOffset: -5,
      },
    ],
    dst: true,
  },
  {
    key: 'BT',
    value: 'Bhutan',
    code: {
      a2: 'BT',
      a3: 'BTN',
    },
    shortList: 'x',
    houseNumber: false,
    state: false,
    parent: null,
    depType: null,
    stateTerm: null,
    currency: {
      code: 'BTN',
      name: 'Bhutanese Ngultrum',
      symbol: 'Nu.',
    },
    num: 64,
    dialingCode: 975,
    langs: [
      {
        name: 'Dzongkha',
        code: 'dz',
      },
    ],
    tz: [
      {
        name: 'Bhutan Time',
        code: 'BTT',
        gmtOffset: '+6',
      },
      {
        name: 'Bhutan Time',
        code: 'BTT',
        gmtOffset: '+6',
      },
    ],
    dst: false,
  },
  {
    key: 'BV',
    value: 'Bouvet Island',
    code: {
      a2: 'BV',
      a3: 'BVT',
    },
    shortList: null,
    houseNumber: false,
    state: false,
    parent: false,
    depType: 'dependent',
    stateTerm: null,
    currency: {
      code: 'NOK',
      name: 'Norwegian Krone',
      symbol: 'kr',
    },
    num: 74,
    dialingCode: 47,
    langs: [
      {
        name: 'Norwegian',
        code: 'nb',
      },
    ],
    tz: [
      {
        name: 'Central European Time',
        code: 'CET',
        gmtOffset: '+1',
      },
      {
        name: 'Central European Time',
        code: 'CET',
        gmtOffset: '+1',
      },
    ],
    dst: null,
  },
  {
    key: 'BW',
    value: 'Botswana',
    code: {
      a2: 'BW',
      a3: 'BWA',
    },
    shortList: 'x',
    houseNumber: false,
    state: false,
    parent: null,
    depType: null,
    stateTerm: null,
    currency: {
      code: 'BWP',
      name: 'Botswana Pula',
      symbol: 'P',
    },
    num: 72,
    dialingCode: 267,
    langs: [
      {
        name: 'Tswana',
        code: 'tn',
      },
      {
        name: 'English',
        code: 'en',
      },
    ],
    tz: [
      {
        name: 'Central Africa Time',
        code: 'CAT',
        gmtOffset: '+2',
      },
      {
        name: 'Central Africa Time',
        code: 'CAT',
        gmtOffset: '+2',
      },
    ],
    dst: false,
  },
  {
    key: 'BY',
    value: 'Belarus',
    code: {
      a2: 'BY',
      a3: 'BLR',
    },
    shortList: 'x',
    houseNumber: false,
    state: false,
    parent: null,
    depType: null,
    stateTerm: null,
    currency: {
      code: 'BYN',
      name: 'Belarusian Ruble',
      symbol: 'Br',
    },
    num: 112,
    dialingCode: 375,
    langs: [
      {
        name: 'Russian',
        code: 'ru',
      },
      {
        name: 'Belarusian',
        code: 'be',
      },
    ],
    tz: [
      {
        name: 'Moscow Standard Time',
        code: 'MSK',
        gmtOffset: '+3',
      },
      {
        name: 'Moscow Standard Time',
        code: 'MSK',
        gmtOffset: '+3',
      },
    ],
    dst: false,
  },
  {
    key: 'BZ',
    value: 'Belize',
    code: {
      a2: 'BZ',
      a3: 'BLZ',
    },
    shortList: 'x',
    houseNumber: false,
    state: false,
    parent: null,
    depType: null,
    stateTerm: null,
    currency: {
      code: 'BZD',
      name: 'Belize Dollar',
      symbol: '$',
    },
    num: 84,
    dialingCode: 501,
    langs: [
      {
        name: 'English',
        code: 'en',
      },
    ],
    tz: [
      {
        name: 'Central Standard Time',
        code: 'CST',
        gmtOffset: -6,
      },
      {
        name: 'Central Standard Time',
        code: 'CST',
        gmtOffset: -6,
      },
    ],
    dst: false,
  },
  {
    key: 'CA',
    value: 'Canada',
    code: {
      a2: 'CA',
      a3: 'CAN',
    },
    shortList: 'CA',
    houseNumber: false,
    state: true,
    parent: 'AU',
    depType: 'dependent',
    stateTerm: 'province',
    currency: {
      code: 'CAD',
      name: 'Canadian Dollar',
      symbol: '$',
    },
    num: 124,
    dialingCode: 1,
    langs: [
      {
        name: 'English',
        code: 'en',
      },
      {
        name: 'French',
        code: 'fr',
      },
    ],
    tz: [
      {
        name: 'Pacific Standard Time',
        code: 'PST',
        gmtOffset: -8,
      },
      {
        name: 'Newfoundland Standard Time',
        code: 'NST',
        gmtOffset: -3.5,
      },
    ],
    dst: true,
  },
  {
    key: 'CC',
    value: 'Cocos (Keeling) Islands',
    code: {
      a2: 'CC',
      a3: 'CCK',
    },
    shortList: null,
    houseNumber: false,
    state: false,
    parent: 'AU',
    depType: 'dependent',
    stateTerm: null,
    currency: {
      code: 'AUD',
      name: 'Australian Dollar',
      symbol: '$',
    },
    num: 166,
    dialingCode: 61,
    langs: [
      {
        name: 'English',
        code: 'en',
      },
    ],
    tz: [
      {
        name: 'Cocos Islands Time',
        code: 'CCT',
        gmtOffset: '+6.5',
      },
      {
        name: 'Cocos Islands Time',
        code: 'CCT',
        gmtOffset: '+6.5',
      },
    ],
    dst: false,
  },
  {
    key: 'CD',
    value: 'Democratic Republic of the Congo',
    code: {
      a2: 'CD',
      a3: 'COD',
    },
    shortList: 'x',
    houseNumber: false,
    state: false,
    parent: null,
    depType: null,
    stateTerm: null,
    currency: {
      code: 'CDF',
      name: 'Congolese Franc',
      symbol: 'FC',
    },
    num: 180,
    dialingCode: 243,
    langs: [
      {
        name: 'French',
        code: 'fr',
      },
    ],
    tz: [
      {
        name: 'West Africa Time',
        code: 'WAT',
        gmtOffset: '+1',
      },
      {
        name: 'Central Africa Time',
        code: 'CAT',
        gmtOffset: '+2',
      },
    ],
    dst: false,
  },
  {
    key: 'CF',
    value: 'Central African Republic',
    code: {
      a2: 'CF',
      a3: 'CAF',
    },
    shortList: 'x',
    houseNumber: false,
    state: false,
    parent: null,
    depType: null,
    stateTerm: null,
    currency: {
      code: 'XAF',
      name: 'Central African CFA franc',
      symbol: 'CFA',
    },
    num: 140,
    dialingCode: 236,
    langs: [
      {
        name: 'Sango',
        code: 'sg',
      },
      {
        name: 'French',
        code: 'fr',
      },
    ],
    tz: [
      {
        name: 'West Africa Time',
        code: 'WAT',
        gmtOffset: '+1',
      },
      {
        name: 'West Africa Time',
        code: 'WAT',
        gmtOffset: '+1',
      },
    ],
    dst: false,
  },
  {
    key: 'CG',
    value: 'Congo',
    code: {
      a2: 'CG',
      a3: 'COG',
    },
    shortList: 'x',
    houseNumber: false,
    state: false,
    parent: null,
    depType: null,
    stateTerm: null,
    currency: {
      code: 'XAF',
      name: 'Central African CFA franc',
      symbol: 'CFA',
    },
    num: 178,
    dialingCode: 242,
    langs: [
      {
        name: 'French',
        code: 'fr',
      },
    ],
    tz: [
      {
        name: 'West Africa Time',
        code: 'WAT',
        gmtOffset: '+1',
      },
      {
        name: 'West Africa Time',
        code: 'WAT',
        gmtOffset: '+1',
      },
    ],
    dst: false,
  },
  {
    key: 'CH',
    value: 'Switzerland',
    code: {
      a2: 'CH',
      a3: 'CHE',
    },
    shortList: 'x',
    houseNumber: true,
    parent: null,
    depType: null,
    stateTerm: null,
    currency: {
      code: 'CHF',
      name: 'Swiss Franc',
      symbol: 'CHF',
    },
    num: 756,
    dialingCode: 41,
    langs: [
      {
        name: 'German',
        code: 'de',
      },
      {
        name: 'French',
        code: 'fr',
      },
      {
        name: 'Italian',
        code: 'it',
      },
      {
        name: 'Romansh',
        code: 'rm',
      },
    ],
    tz: [
      {
        name: 'Central European Time',
        code: 'CET',
        gmtOffset: '+1',
      },
      {
        name: 'Central European Time',
        code: 'CET',
        gmtOffset: '+1',
      },
    ],
    dst: true,
  },
  {
    key: 'CI',
    value: 'Cote d\'Ivoire',
    code: {
      a2: 'CI',
      a3: 'CIV',
    },
    shortList: 'x',
    houseNumber: false,
    state: false,
    parent: null,
    depType: null,
    stateTerm: null,
    currency: {
      code: 'XOF',
      name: 'West African CFA franc',
      symbol: null,
    },
    num: 384,
    dialingCode: 225,
    langs: [
      {
        name: 'French',
        code: 'fr',
      },
    ],
    tz: [
      {
        name: 'Greenwich Mean Time',
        code: 'GMT',
        gmtOffset: '+0',
      },
      {
        name: 'Greenwich Mean Time',
        code: 'GMT',
        gmtOffset: '+0',
      },
    ],
    dst: false,
  },
  {
    key: 'CK',
    value: 'Cook Islands',
    code: {
      a2: 'CK',
      a3: 'COK',
    },
    shortList: null,
    houseNumber: false,
    state: false,
    parent: 'NZ',
    depType: 'associated',
    stateTerm: null,
    currency: {
      code: 'NZD',
      name: 'Cook Islands Dollar',
      symbol: '$',
    },
    num: 184,
    dialingCode: 682,
    langs: [
      {
        name: 'Cook Islands Maori',
        code: null,
      },
    ],
    tz: [
      {
        name: 'Cook Islands Time',
        code: 'CKT',
        gmtOffset: -10,
      },
      {
        name: 'Cook Islands Time',
        code: 'CKT',
        gmtOffset: -10,
      },
    ],
    dst: false,
  },
  {
    key: 'CL',
    value: 'Chile',
    code: {
      a2: 'CL',
      a3: 'CHL',
    },
    shortList: 'x',
    houseNumber: false,
    state: false,
    parent: null,
    depType: null,
    stateTerm: null,
    currency: {
      code: 'CLP',
      name: 'Chilean Peso',
      symbol: '$',
    },
    num: 152,
    dialingCode: 56,
    langs: [
      {
        name: 'Spanish',
        code: 'es',
      },
    ],
    tz: [
      {
        name: 'Easter Island Standard Time',
        code: 'EAST',
        gmtOffset: -6,
      },
      {
        name: 'Chile Standard Time',
        code: 'CLT',
        gmtOffset: -4,
      },
    ],
    dst: true,
  },
  {
    key: 'CM',
    value: 'Cameroon',
    code: {
      a2: 'CM',
      a3: 'CMR',
    },
    shortList: 'x',
    houseNumber: false,
    state: false,
    parent: null,
    depType: null,
    stateTerm: null,
    currency: {
      code: 'XAF',
      name: 'Central African CFA franc',
      symbol: null,
    },
    num: 120,
    dialingCode: 237,
    langs: [
      {
        name: 'French',
        code: 'fr',
      },
      {
        name: 'English',
        code: 'en',
      },
    ],
    tz: [
      {
        name: 'West Africa Time',
        code: 'WAT',
        gmtOffset: '+1',
      },
      {
        name: 'West Africa Time',
        code: 'WAT',
        gmtOffset: '+1',
      },
    ],
    dst: false,
  },
  {
    key: 'CN',
    value: 'China',
    code: {
      a2: 'CN',
      a3: 'CHN',
    },
    shortList: 'x',
    houseNumber: false,
    state: true,
    parent: null,
    depType: null,
    stateTerm: 'province',
    currency: {
      code: 'CNY',
      name: 'Chinese Yuan',
      symbol: '¥',
    },
    num: 156,
    dialingCode: 86,
    langs: [
      {
        name: 'Mandarin Chinese',
        code: 'zh',
      },
    ],
    tz: [
      {
        name: 'China Standard Time',
        code: 'CST',
        gmtOffset: '+8',
      },
      {
        name: 'China Standard Time',
        code: 'CST',
        gmtOffset: '+8',
      },
    ],
    dst: false,
  },
  {
    key: 'CO',
    value: 'Colombia',
    code: {
      a2: 'CO',
      a3: 'COL',
    },
    shortList: 'x',
    houseNumber: false,
    state: true,
    parent: null,
    depType: null,
    stateTerm: 'department',
    currency: {
      code: 'COP',
      name: 'Colombian Peso',
      symbol: '$',
    },
    num: 170,
    dialingCode: 57,
    langs: [
      {
        name: 'Spanish',
        code: 'es',
      },
    ],
    tz: [
      {
        name: 'Colombia Time',
        code: 'COT',
        gmtOffset: -5,
      },
      {
        name: 'Colombia Time',
        code: 'COT',
        gmtOffset: -5,
      },
    ],
    dst: false,
  },
  {
    key: 'CR',
    value: 'Costa Rica',
    code: {
      a2: 'CR',
      a3: 'CRI',
    },
    shortList: 'x',
    houseNumber: false,
    state: false,
    parent: null,
    depType: null,
    stateTerm: null,
    currency: {
      code: 'CRC',
      name: 'Costa Rican Colón',
      symbol: '₡',
    },
    num: 188,
    dialingCode: 506,
    langs: [
      {
        name: 'Spanish',
        code: 'es',
      },
    ],
    tz: [
      {
        name: 'Central Standard Time',
        code: 'CST',
        gmtOffset: -6,
      },
      {
        name: 'Central Standard Time',
        code: 'CST',
        gmtOffset: -6,
      },
    ],
    dst: false,
  },
  {
    key: 'CU',
    value: 'Cuba',
    code: {
      a2: 'CU',
      a3: 'CUB',
    },
    shortList: 'x',
    houseNumber: false,
    state: false,
    parent: null,
    depType: null,
    stateTerm: null,
    currency: {
      code: 'CUP',
      name: 'Cuban Peso',
      symbol: null,
    },
    num: 192,
    dialingCode: 53,
    langs: [
      {
        name: 'Spanish',
        code: 'es',
      },
    ],
    tz: [
      {
        name: 'Cuba Standard Time',
        code: 'CST',
        gmtOffset: -5,
      },
      {
        name: 'Cuba Standard Time',
        code: 'CST',
        gmtOffset: -5,
      },
    ],
    dst: true,
  },
  {
    key: 'CV',
    value: 'Cape Verde',
    code: {
      a2: 'CV',
      a3: 'CPV',
    },
    shortList: 'x',
    houseNumber: false,
    state: false,
    parent: null,
    depType: null,
    stateTerm: null,
    currency: {
      code: 'CVE',
      name: 'Cape Verdean Escudo',
      symbol: null,
    },
    num: 132,
    dialingCode: 238,
    langs: [
      {
        name: 'Portuguese',
        code: 'pt',
      },
      {
        name: 'Cape Verdean Creole',
        code: null,
      },
    ],
    tz: [
      {
        name: 'Cape Verde Time',
        code: 'CVT',
        gmtOffset: -1,
      },
      {
        name: 'Cape Verde Time',
        code: 'CVT',
        gmtOffset: -1,
      },
    ],
    dst: false,
  },
  {
    key: 'CW',
    value: 'Curacao',
    code: {
      a2: 'CW',
      a3: 'CUW',
    },
    shortList: null,
    houseNumber: false,
    state: false,
    parent: 'NL',
    depType: 'dependent',
    stateTerm: null,
    currency: {
      code: 'ANG',
      name: 'Netherlands Antillean Guilder',
      symbol: 'ƒ',
    },
    num: 531,
    dialingCode: 599,
    langs: [
      {
        name: 'Papiamento',
        code: 'pap',
      },
      {
        name: 'Dutch',
        code: 'nl',
      },
      {
        name: 'English',
        code: 'en',
      },
    ],
    tz: [
      {
        name: 'Atlantic Standard Time',
        code: 'AST',
        gmtOffset: -4,
      },
      {
        name: 'Atlantic Standard Time',
        code: 'AST',
        gmtOffset: -4,
      },
    ],
    dst: false,
  },
  {
    key: 'CX',
    value: 'Christmas Island',
    code: {
      a2: 'CX',
      a3: 'CXR',
    },
    shortList: null,
    houseNumber: false,
    state: false,
    parent: 'AU',
    depType: 'dependent',
    stateTerm: null,
    currency: {
      code: 'AUD',
      name: 'Australian Dollar',
      symbol: '$',
    },
    num: 162,
    dialingCode: 61,
    langs: [
      {
        name: 'English',
        code: 'en',
      },
    ],
    tz: [
      {
        name: 'Christmas Island Time',
        code: 'CXT',
        gmtOffset: '+7',
      },
      {
        name: 'Christmas Island Time',
        code: 'CXT',
        gmtOffset: '+7',
      },
    ],
    dst: false,
  },
  {
    key: 'CY',
    value: 'Cyprus',
    code: {
      a2: 'CY',
      a3: 'CYP',
    },
    shortList: 'x',
    houseNumber: false,
    state: false,
    parent: null,
    depType: null,
    stateTerm: null,
    currency: {
      code: 'EUR',
      name: 'Euro',
      symbol: '€',
    },
    num: 196,
    dialingCode: 357,
    langs: [
      {
        name: 'Greek',
        code: 'el',
      },
      {
        name: 'Turkish',
        code: 'tr',
      },
    ],
    tz: [
      {
        name: 'Eastern European Time',
        code: 'EET',
        gmtOffset: '+2',
      },
      {
        name: 'Eastern European Time',
        code: 'EET',
        gmtOffset: '+2',
      },
    ],
    dst: true,
  },
  {
    key: 'CZ',
    value: 'Czech Republic',
    code: {
      a2: 'CZ',
      a3: 'CZE',
    },
    shortList: 'x',
    houseNumber: true,
    parent: null,
    depType: null,
    stateTerm: null,
    currency: {
      code: 'CZK',
      name: 'Czech Koruna',
      symbol: 'Kč',
    },
    num: 203,
    dialingCode: 420,
    langs: [
      {
        name: 'Czech',
        code: 'cs',
      },
    ],
    tz: [
      {
        name: 'Central European Time',
        code: 'CET',
        gmtOffset: '+1',
      },
      {
        name: 'Central European Time',
        code: 'CET',
        gmtOffset: '+1',
      },
    ],
    dst: true,
  },
  {
    key: 'DE',
    value: 'Germany',
    code: {
      a2: 'DE',
      a3: 'DEU',
    },
    shortList: 'x',
    houseNumber: true,
    parent: null,
    depType: null,
    stateTerm: null,
    currency: {
      code: 'EUR',
      name: 'Euro',
      symbol: '€',
    },
    num: 276,
    dialingCode: 49,
    langs: [
      {
        name: 'German',
        code: 'de',
      },
    ],
    tz: [
      {
        name: 'Central European Time',
        code: 'CET',
        gmtOffset: '+1',
      },
      {
        name: 'Central European Time',
        code: 'CET',
        gmtOffset: '+1',
      },
    ],
    dst: true,
  },
  {
    key: 'DJ',
    value: 'Djibouti',
    code: {
      a2: 'DJ',
      a3: 'DJI',
    },
    shortList: 'x',
    houseNumber: false,
    state: false,
    parent: null,
    depType: null,
    stateTerm: null,
    currency: {
      code: 'DJF',
      name: 'Djiboutian Franc',
      symbol: 'Fdj',
    },
    num: 262,
    dialingCode: 253,
    langs: [
      {
        name: 'Arabic',
        code: 'ar',
      },
      {
        name: 'French',
        code: 'fr',
      },
    ],
    tz: [
      {
        name: 'East Africa Time',
        code: 'EAT',
        gmtOffset: '+3',
      },
      {
        name: 'East Africa Time',
        code: 'EAT',
        gmtOffset: '+3',
      },
    ],
    dst: false,
  },
  {
    key: 'DK',
    value: 'Denmark',
    code: {
      a2: 'DK',
      a3: 'DNK',
    },
    shortList: 'x',
    houseNumber: true,
    parent: null,
    depType: null,
    stateTerm: null,
    currency: {
      code: 'DKK',
      name: 'Danish Krone',
      symbol: 'kr',
    },
    num: 208,
    dialingCode: 45,
    langs: [
      {
        name: 'Danish',
        code: 'da',
      },
    ],
    tz: [
      {
        name: 'Central European Time',
        code: 'CET',
        gmtOffset: '+1',
      },
      {
        name: 'Central European Time',
        code: 'CET',
        gmtOffset: '+1',
      },
    ],
    dst: true,
  },
  {
    key: 'DM',
    value: 'Dominica',
    code: {
      a2: 'DM',
      a3: 'DMA',
    },
    shortList: 'x',
    houseNumber: false,
    state: false,
    parent: null,
    depType: null,
    stateTerm: null,
    currency: {
      code: 'XCD',
      name: 'East Caribbean Dollar',
      symbol: null,
    },
    num: 212,
    dialingCode: '1-767',
    langs: [
      {
        name: 'English',
        code: 'en',
      },
    ],
    tz: [
      {
        name: 'Atlantic Standard Time',
        code: 'AST',
        gmtOffset: -4,
      },
      {
        name: 'Atlantic Standard Time',
        code: 'AST',
        gmtOffset: -4,
      },
    ],
    dst: false,
  },
  {
    key: 'DO',
    value: 'Dominican Republic',
    code: {
      a2: 'DO',
      a3: 'DOM',
    },
    shortList: 'x',
    houseNumber: false,
    state: false,
    parent: null,
    depType: null,
    stateTerm: null,
    currency: {
      code: 'DOP',
      name: 'Dominican Peso',
      symbol: 'RD$',
    },
    num: 214,
    dialingCode: '1-809,1-829,1-849',
    langs: [
      {
        name: 'Spanish',
        code: 'es',
      },
    ],
    tz: [
      {
        name: 'Atlantic Standard Time',
        code: 'AST',
        gmtOffset: -4,
      },
      {
        name: 'Atlantic Standard Time',
        code: 'AST',
        gmtOffset: -4,
      },
    ],
    dst: false,
  },
  {
    key: 'DZ',
    value: 'Algeria',
    code: {
      a2: 'DZ',
      a3: 'DZA',
    },
    shortList: 'x',
    houseNumber: false,
    state: false,
    parent: null,
    depType: null,
    stateTerm: null,
    currency: {
      code: 'DZD',
      name: 'Algerian Dinar',
      symbol: 'د.ج',
    },
    num: 12,
    dialingCode: 213,
    langs: [
      {
        name: 'Arabic',
        code: 'ar',
      },
      {
        name: 'Berber',
        code: 'kab',
      },
    ],
    tz: [
      {
        name: 'Central European Time',
        code: 'CET',
        gmtOffset: '+1',
      },
      {
        name: 'Central European Time',
        code: 'CET',
        gmtOffset: '+1',
      },
    ],
    dst: false,
  },
  {
    key: 'EC',
    value: 'Ecuador',
    code: {
      a2: 'EC',
      a3: 'ECU',
    },
    shortList: 'x',
    houseNumber: false,
    state: false,
    parent: null,
    depType: null,
    stateTerm: null,
    currency: {
      code: 'USD',
      name: 'US Dollar',
      symbol: '$',
    },
    num: 218,
    dialingCode: 593,
    langs: [
      {
        name: 'Spanish',
        code: 'es',
      },
      {
        name: 'Quechua',
        code: 'qu',
      },
    ],
    tz: [
      {
        name: 'Galapagos Time',
        code: 'GALT',
        gmtOffset: -6,
      },
      {
        name: 'Ecuador Time',
        code: 'ECT',
        gmtOffset: -5,
      },
    ],
    dst: false,
  },
  {
    key: 'EE',
    value: 'Estonia',
    code: {
      a2: 'EE',
      a3: 'EST',
    },
    shortList: 'x',
    houseNumber: false,
    state: false,
    parent: null,
    depType: null,
    stateTerm: null,
    currency: {
      code: 'EUR',
      name: 'Euro',
      symbol: '€',
    },
    num: 233,
    dialingCode: 372,
    langs: [
      {
        name: 'Estonian',
        code: 'et',
      },
    ],
    tz: [
      {
        name: 'Eastern European Time',
        code: 'EET',
        gmtOffset: '+2',
      },
      {
        name: 'Eastern European Time',
        code: 'EET',
        gmtOffset: '+2',
      },
    ],
    dst: true,
  },
  {
    key: 'EG',
    value: 'Egypt',
    code: {
      a2: 'EG',
      a3: 'EGY',
    },
    shortList: 'x',
    houseNumber: false,
    state: false,
    parent: null,
    depType: null,
    stateTerm: null,
    currency: {
      code: 'EGP',
      name: 'Egyptian Pound',
      symbol: 'E£',
    },
    num: 818,
    dialingCode: 20,
    langs: [
      {
        name: 'Arabic',
        code: 'ar',
      },
    ],
    tz: [
      {
        name: 'Eastern European Time',
        code: 'EET',
        gmtOffset: '+2',
      },
      {
        name: 'Eastern European Time',
        code: 'EET',
        gmtOffset: '+2',
      },
    ],
    dst: false,
  },
  {
    key: 'EH',
    value: 'Western Sahara',
    code: {
      a2: 'EH',
      a3: 'ESH',
    },
    shortList: null,
    houseNumber: false,
    state: false,
    parent: 'MA',
    depType: 'occupied',
    stateTerm: null,
    currency: {
      code: null,
      name: null,
      symbol: null,
    },
    num: 732,
    dialingCode: 212,
    langs: [
      {
        name: 'Arabic',
        code: 'ar',
      },
      {
        name: 'Berber',
        code: 'ber',
      },
    ],
    tz: [
      {
        name: 'Western European Time',
        code: 'WET',
        gmtOffset: '+0',
      },
      {
        name: 'Western European Time',
        code: 'WET',
        gmtOffset: '+0',
      },
    ],
    dst: false,
  },
  {
    key: 'ER',
    value: 'Eritrea',
    code: {
      a2: 'ER',
      a3: 'ERI',
    },
    shortList: 'x',
    houseNumber: false,
    state: false,
    parent: null,
    depType: null,
    stateTerm: null,
    currency: {
      code: 'ERN',
      name: 'Eritrean Nakfa',
      symbol: null,
    },
    num: 232,
    dialingCode: 291,
    langs: [
      {
        name: 'Tigrinya',
        code: 'ti',
      },
      {
        name: 'Arabic',
        code: 'ar',
      },
      {
        name: 'English',
        code: 'en',
      },
    ],
    tz: [
      {
        name: 'East Africa Time',
        code: 'EAT',
        gmtOffset: '+3',
      },
      {
        name: 'East Africa Time',
        code: 'EAT',
        gmtOffset: '+3',
      },
    ],
    dst: false,
  },
  {
    key: 'ES',
    value: 'Spain',
    code: {
      a2: 'ES',
      a3: 'ESP',
    },
    shortList: 'x',
    houseNumber: false,
    state: true,
    parent: null,
    depType: null,
    stateTerm: 'region',
    currency: {
      code: 'EUR',
      name: 'Euro',
      symbol: '€',
    },
    num: 724,
    dialingCode: 34,
    langs: [
      {
        name: 'Spanish',
        code: 'es',
      },
      {
        name: 'Catalan',
        code: 'ca',
      },
      {
        name: 'Basque',
        code: 'eu',
      },
      {
        name: 'Galician',
        code: 'gl',
      },
    ],
    tz: [
      {
        name: 'Western European Time',
        code: 'WET',
        gmtOffset: '+0',
      },
      {
        name: 'Central European Time',
        code: 'CET',
        gmtOffset: '+1',
      },
    ],
    dst: true,
  },
  {
    key: 'ET',
    value: 'Ethiopia',
    code: {
      a2: 'ET',
      a3: 'ETH',
    },
    shortList: 'x',
    houseNumber: false,
    state: false,
    parent: null,
    depType: null,
    stateTerm: null,
    currency: {
      code: 'ETB',
      name: 'Ethiopian Birr',
      symbol: 'Br',
    },
    num: 231,
    dialingCode: 251,
    langs: [
      {
        name: 'Amharic',
        code: 'am',
      },
    ],
    tz: [
      {
        name: 'East Africa Time',
        code: 'EAT',
        gmtOffset: '+3',
      },
      {
        name: 'East Africa Time',
        code: 'EAT',
        gmtOffset: '+3',
      },
    ],
    dst: false,
  },
  {
    key: 'FI',
    value: 'Finland',
    code: {
      a2: 'FI',
      a3: 'FIN',
    },
    shortList: 'x',
    houseNumber: true,
    parent: null,
    depType: null,
    stateTerm: null,
    currency: {
      code: 'EUR',
      name: 'Euro',
      symbol: '€',
    },
    num: 246,
    dialingCode: 358,
    langs: [
      {
        name: 'Finnish',
        code: 'fi',
      },
      {
        name: 'Swedish',
        code: 'sv',
      },
    ],
    tz: [
      {
        name: 'Eastern European Time',
        code: 'EET',
        gmtOffset: '+2',
      },
      {
        name: 'Eastern European Time',
        code: 'EET',
        gmtOffset: '+2',
      },
    ],
    dst: true,
  },
  {
    key: 'FJ',
    value: 'Fiji',
    code: {
      a2: 'FJ',
      a3: 'FJI',
    },
    shortList: 'x',
    houseNumber: false,
    state: false,
    parent: null,
    depType: null,
    stateTerm: null,
    currency: {
      code: 'FJD',
      name: 'Fijian Dollar',
      symbol: '$',
    },
    num: 242,
    dialingCode: 679,
    langs: [
      {
        name: 'English',
        code: 'en',
      },
      {
        name: 'Fijian',
        code: 'fj',
      },
      {
        name: 'Fiji Hindi',
        code: 'hif',
      },
    ],
    tz: [
      {
        name: 'Fiji Time',
        code: 'FJT',
        gmtOffset: '+12',
      },
      {
        name: 'Fiji Time',
        code: 'FJT',
        gmtOffset: '+12',
      },
    ],
    dst: true,
  },
  {
    key: 'FK',
    value: 'Falkland Islands (Malvinas)',
    code: {
      a2: 'FK',
      a3: 'FLK',
    },
    shortList: null,
    houseNumber: false,
    state: false,
    parent: 'GB',
    depType: 'dependent',
    stateTerm: null,
    currency: {
      code: 'FKP',
      name: 'Falkland Islands Pound',
      symbol: '£',
    },
    num: 238,
    dialingCode: 500,
    langs: [
      {
        name: 'English',
        code: 'en',
      },
    ],
    tz: [
      {
        name: 'Falkland Islands Time',
        code: 'FKT',
        gmtOffset: -3,
      },
      {
        name: 'Falkland Islands Time',
        code: 'FKT',
        gmtOffset: -3,
      },
    ],
    dst: true,
  },
  {
    key: 'FM',
    value: 'Micronesia',
    code: {
      a2: 'FM',
      a3: 'FSM',
    },
    shortList: 'x',
    houseNumber: false,
    state: false,
    parent: null,
    depType: null,
    stateTerm: null,
    currency: {
      code: 'USD',
      name: 'US Dollar',
      symbol: '$',
    },
    num: 583,
    dialingCode: 691,
    langs: [
      {
        name: 'English',
        code: 'en',
      },
    ],
    tz: [
      {
        name: 'Chuuk Time',
        code: 'CHUT',
        gmtOffset: '+10',
      },
      {
        name: 'Pohnpei Time',
        code: 'PONT',
        gmtOffset: '+11',
      },
    ],
    dst: false,
  },
  {
    key: 'FO',
    value: 'Faroe Islands',
    code: {
      a2: 'FO',
      a3: 'FRO',
    },
    shortList: null,
    houseNumber: false,
    state: false,
    parent: 'GB',
    depType: 'dependent',
    stateTerm: null,
    currency: {
      code: 'DKK',
      name: 'Danish Krone',
      symbol: 'kr',
    },
    num: 234,
    dialingCode: 298,
    langs: [
      {
        name: 'Faroese',
        code: 'fo',
      },
      {
        name: 'Danish',
        code: 'da',
      },
    ],
    tz: [
      {
        name: 'Western European Time',
        code: 'WET',
        gmtOffset: '+0',
      },
      {
        name: 'Western European Time',
        code: 'WET',
        gmtOffset: '+0',
      },
    ],
    dst: true,
  },
  {
    key: 'FR',
    value: 'France',
    code: {
      a2: 'FR',
      a3: 'FRA',
    },
    shortList: 'x',
    houseNumber: true,
    parent: null,
    depType: null,
    stateTerm: null,
    currency: {
      code: 'EUR',
      name: 'Euro',
      symbol: '€',
    },
    num: 250,
    dialingCode: 33,
    langs: [
      {
        name: 'French',
        code: 'fr',
      },
    ],
    tz: [
      {
        name: 'Central European Time',
        code: 'CET',
        gmtOffset: '+1',
      },
      {
        name: 'Central European Time',
        code: 'CET',
        gmtOffset: '+1',
      },
    ],
    dst: true,
  },
  {
    key: 'GA',
    value: 'Gabon',
    code: {
      a2: 'GA',
      a3: 'GAB',
    },
    shortList: 'x',
    houseNumber: false,
    state: false,
    parent: null,
    depType: null,
    stateTerm: null,
    currency: {
      code: 'XAF',
      name: 'Central African CFA franc',
      symbol: null,
    },
    num: 266,
    dialingCode: 241,
    langs: [
      {
        name: 'French',
        code: 'fr',
      },
    ],
    tz: [
      {
        name: 'West Africa Time',
        code: 'WAT',
        gmtOffset: '+1',
      },
      {
        name: 'West Africa Time',
        code: 'WAT',
        gmtOffset: '+1',
      },
    ],
    dst: false,
  },
  {
    key: 'GB',
    value: 'United Kingdom',
    code: {
      a2: 'GB',
      a3: 'GBR',
    },
    shortList: 'x',
    houseNumber: false,
    state: false,
    parent: null,
    depType: null,
    stateTerm: null,
    currency: {
      code: 'GBP',
      name: 'Pound Sterling',
      symbol: '£',
    },
    num: 826,
    dialingCode: 44,
    langs: [
      {
        name: 'English',
        code: 'en',
      },
      {
        name: 'Welsh',
        code: 'cy',
      },
    ],
    tz: [
      {
        name: 'Greenwich Mean Time',
        code: 'GMT',
        gmtOffset: '+0',
      },
      {
        name: 'Greenwich Mean Time',
        code: 'GMT',
        gmtOffset: '+0',
      },
    ],
    dst: true,
  },
  {
    key: 'GD',
    value: 'Grenada',
    code: {
      a2: 'GD',
      a3: 'GRD',
    },
    shortList: 'x',
    houseNumber: false,
    state: false,
    parent: null,
    depType: null,
    stateTerm: null,
    currency: {
      code: 'XCD',
      name: 'East Caribbean Dollar',
      symbol: null,
    },
    num: 308,
    dialingCode: '1-473',
    langs: [
      {
        name: 'English',
        code: 'en',
      },
    ],
    tz: [
      {
        name: 'Atlantic Standard Time',
        code: 'AST',
        gmtOffset: -4,
      },
      {
        name: 'Atlantic Standard Time',
        code: 'AST',
        gmtOffset: -4,
      },
    ],
    dst: false,
  },
  {
    key: 'GE',
    value: 'Georgia',
    code: {
      a2: 'GE',
      a3: 'GEO',
    },
    shortList: 'x',
    houseNumber: false,
    state: false,
    parent: null,
    depType: null,
    stateTerm: null,
    currency: {
      code: 'GEL',
      name: 'Georgian Lari',
      symbol: 'ლ',
    },
    num: 268,
    dialingCode: 995,
    langs: [
      {
        name: 'Georgian',
        code: 'ka',
      },
    ],
    tz: [
      {
        name: 'Georgia Standard Time',
        code: 'GET',
        gmtOffset: '+4',
      },
      {
        name: 'Georgia Standard Time',
        code: 'GET',
        gmtOffset: '+4',
      },
    ],
    dst: false,
  },
  {
    key: 'GF',
    value: 'French Guiana',
    code: {
      a2: 'GF',
      a3: 'GUF',
    },
    shortList: null,
    houseNumber: false,
    state: false,
    parent: 'FR',
    depType: 'dependent',
    stateTerm: null,
    currency: {
      code: 'EUR',
      name: 'Euro',
      symbol: '€',
    },
    num: 254,
    dialingCode: 594,
    langs: [
      {
        name: 'French',
        code: 'fr',
      },
    ],
    tz: [
      {
        name: 'French Guiana Time',
        code: 'GFT',
        gmtOffset: -3,
      },
      {
        name: 'French Guiana Time',
        code: 'GFT',
        gmtOffset: -3,
      },
    ],
    dst: false,
  },
  {
    key: 'GG',
    value: 'Guernsey',
    code: {
      a2: 'GG',
      a3: 'GGY',
    },
    shortList: null,
    houseNumber: false,
    state: false,
    parent: 'GB',
    depType: 'dependent',
    stateTerm: null,
    currency: {
      code: 'GBP',
      name: 'Pound Sterling',
      symbol: '£',
    },
    num: 831,
    dialingCode: 44,
    langs: [
      {
        name: 'English',
        code: 'en',
      },
    ],
    tz: [
      {
        name: 'Greenwich Mean Time',
        code: 'GMT',
        gmtOffset: '+0',
      },
      {
        name: 'Greenwich Mean Time',
        code: 'GMT',
        gmtOffset: '+0',
      },
    ],
    dst: true,
  },
  {
    key: 'GH',
    value: 'Ghana',
    code: {
      a2: 'GH',
      a3: 'GHA',
    },
    shortList: 'x',
    houseNumber: false,
    state: false,
    parent: null,
    depType: null,
    stateTerm: null,
    currency: {
      code: 'GHS',
      name: 'Ghanaian Cedi',
      symbol: '₵',
    },
    num: 288,
    dialingCode: 233,
    langs: [
      {
        name: 'English',
        code: 'en',
      },
    ],
    tz: [
      {
        name: 'Greenwich Mean Time',
        code: 'GMT',
        gmtOffset: '+0',
      },
      {
        name: 'Greenwich Mean Time',
        code: 'GMT',
        gmtOffset: '+0',
      },
    ],
    dst: false,
  },
  {
    key: 'GI',
    value: 'Gibraltar',
    code: {
      a2: 'GI',
      a3: 'GIB',
    },
    shortList: null,
    houseNumber: false,
    state: false,
    parent: 'GB',
    depType: 'dependent',
    stateTerm: null,
    currency: {
      code: 'GIP',
      name: 'Gibraltar Pound',
      symbol: '£',
    },
    num: 292,
    dialingCode: 350,
    langs: [
      {
        name: 'English',
        code: 'en',
      },
      {
        name: 'Spanish',
        code: 'es',
      },
    ],
    tz: [
      {
        name: 'Central European Time',
        code: 'CET',
        gmtOffset: '+1',
      },
      {
        name: 'Central European Time',
        code: 'CET',
        gmtOffset: '+1',
      },
    ],
    dst: true,
  },
  {
    key: 'GL',
    value: 'Greenland',
    code: {
      a2: 'GL',
      a3: 'GRL',
    },
    shortList: null,
    houseNumber: false,
    state: false,
    parent: 'DK',
    depType: 'dependent',
    stateTerm: null,
    currency: {
      code: 'DKK',
      name: 'Danish Krone',
      symbol: 'kr',
    },
    num: 304,
    dialingCode: 299,
    langs: [
      {
        name: 'Greenlandic',
        code: 'kl',
      },
      {
        name: 'Danish',
        code: 'da',
      },
    ],
    tz: [
      {
        name: 'West Greenland Time',
        code: 'WGT',
        gmtOffset: -4,
      },
      {
        name: 'East Greenland Time',
        code: 'EGT',
        gmtOffset: -1,
      },
    ],
    dst: true,
  },
  {
    key: 'GM',
    value: 'Gambia',
    code: {
      a2: 'GM',
      a3: 'GMB',
    },
    shortList: 'x',
    houseNumber: false,
    state: false,
    parent: null,
    depType: null,
    stateTerm: null,
    currency: {
      code: 'GMD',
      name: 'Gambian Dalasi',
      symbol: 'D',
    },
    num: 270,
    dialingCode: 220,
    langs: [
      {
        name: 'English',
        code: 'en',
      },
    ],
    tz: [
      {
        name: 'Greenwich Mean Time',
        code: 'GMT',
        gmtOffset: '+0',
      },
      {
        name: 'Greenwich Mean Time',
        code: 'GMT',
        gmtOffset: '+0',
      },
    ],
    dst: false,
  },
  {
    key: 'GN',
    value: 'Guinea',
    code: {
      a2: 'GN',
      a3: 'GIN',
    },
    shortList: 'x',
    houseNumber: false,
    state: false,
    parent: null,
    depType: null,
    stateTerm: null,
    currency: {
      code: 'GNF',
      name: 'Guinean Franc',
      symbol: 'F',
    },
    num: 324,
    dialingCode: 224,
    langs: [
      {
        name: 'French',
        code: 'fr',
      },
    ],
    tz: [
      {
        name: 'Greenwich Mean Time',
        code: 'GMT',
        gmtOffset: '+0',
      },
      {
        name: 'Greenwich Mean Time',
        code: 'GMT',
        gmtOffset: '+0',
      },
    ],
    dst: false,
  },
  {
    key: 'GP',
    value: 'Guadeloupe',
    code: {
      a2: 'GP',
      a3: 'GLP',
    },
    shortList: null,
    houseNumber: false,
    state: false,
    parent: 'FR',
    depType: 'dependent',
    stateTerm: null,
    currency: {
      code: 'EUR',
      name: 'Euro',
      symbol: '€',
    },
    num: 312,
    dialingCode: 590,
    langs: [
      {
        name: 'French',
        code: 'fr',
      },
    ],
    tz: [
      {
        name: 'Atlantic Standard Time',
        code: 'AST',
        gmtOffset: -4,
      },
      {
        name: 'Atlantic Standard Time',
        code: 'AST',
        gmtOffset: -4,
      },
    ],
    dst: false,
  },
  {
    key: 'GQ',
    value: 'Equatorial Guinea',
    code: {
      a2: 'GQ',
      a3: 'GNQ',
    },
    shortList: 'x',
    houseNumber: false,
    state: false,
    parent: null,
    depType: null,
    stateTerm: null,
    currency: {
      code: 'XAF',
      name: 'Central African CFA franc',
      symbol: null,
    },
    num: 226,
    dialingCode: 240,
    langs: [
      {
        name: 'Spanish',
        code: 'es',
      },
      {
        name: 'French',
        code: 'fr',
      },
      {
        name: 'Portuguese',
        code: 'pt',
      },
    ],
    tz: [
      {
        name: 'West Africa Time',
        code: 'WAT',
        gmtOffset: '+1',
      },
      {
        name: 'West Africa Time',
        code: 'WAT',
        gmtOffset: '+1',
      },
    ],
    dst: false,
  },
  {
    key: 'GR',
    value: 'Greece',
    code: {
      a2: 'GR',
      a3: 'GRC',
    },
    shortList: 'x',
    houseNumber: false,
    state: false,
    parent: null,
    depType: null,
    stateTerm: null,
    currency: {
      code: 'EUR',
      name: 'Euro',
      symbol: '€',
    },
    num: 300,
    dialingCode: 30,
    langs: [
      {
        name: 'Greek',
        code: 'el',
      },
    ],
    tz: [
      {
        name: 'Eastern European Time',
        code: 'EET',
        gmtOffset: '+2',
      },
      {
        name: 'Eastern European Time',
        code: 'EET',
        gmtOffset: '+2',
      },
    ],
    dst: true,
  },
  {
    key: 'GS',
    value: 'South Georgia and the South Sandwich Islands',
    code: {
      a2: 'GS',
      a3: 'SGS',
    },
    shortList: null,
    houseNumber: false,
    state: false,
    parent: 'GB',
    depType: 'dependent',
    stateTerm: null,
    currency: {
      code: 'GBP',
      name: 'Pound Sterling',
      symbol: '£',
    },
    num: 239,
    dialingCode: 500,
    langs: [
      {
        name: 'English',
        code: 'en',
      },
    ],
    tz: [
      {
        name: 'South Georgia Time',
        code: 'GST',
        gmtOffset: -2,
      },
      {
        name: 'South Georgia Time',
        code: 'GST',
        gmtOffset: -2,
      },
    ],
    dst: false,
  },
  {
    key: 'GT',
    value: 'Guatemala',
    code: {
      a2: 'GT',
      a3: 'GTM',
    },
    shortList: 'x',
    houseNumber: false,
    state: false,
    parent: null,
    depType: null,
    stateTerm: null,
    currency: {
      code: 'GTQ',
      name: 'Guatemalan Quetzal',
      symbol: 'Q',
    },
    num: 320,
    dialingCode: 502,
    langs: [
      {
        name: 'Spanish',
        code: 'es',
      },
    ],
    tz: [
      {
        name: 'Central Standard Time',
        code: 'CST',
        gmtOffset: -6,
      },
      {
        name: 'Central Standard Time',
        code: 'CST',
        gmtOffset: -6,
      },
    ],
    dst: false,
  },
  {
    key: 'GU',
    value: 'Guam',
    code: {
      a2: 'GU',
      a3: 'GUM',
    },
    shortList: null,
    houseNumber: false,
    state: false,
    parent: 'US',
    depType: 'dependent',
    stateTerm: null,
    currency: {
      code: 'USD',
      name: 'US Dollar',
      symbol: '$',
    },
    num: 316,
    dialingCode: '1-671',
    langs: [
      {
        name: 'Chamorro',
        code: 'ch',
      },
      {
        name: 'English',
        code: 'en',
      },
    ],
    tz: [
      {
        name: 'Chamorro Standard Time',
        code: 'ChST',
        gmtOffset: '+10',
      },
      {
        name: 'Chamorro Standard Time',
        code: 'ChST',
        gmtOffset: '+10',
      },
    ],
    dst: false,
  },
  {
    key: 'GW',
    value: 'Guinea-Bissau',
    code: {
      a2: 'GW',
      a3: 'GNB',
    },
    shortList: 'x',
    houseNumber: false,
    state: false,
    parent: null,
    depType: null,
    stateTerm: null,
    currency: {
      code: 'XOF',
      name: 'West African CFA franc',
      symbol: null,
    },
    num: 624,
    dialingCode: 245,
    langs: [
      {
        name: 'Portuguese',
        code: 'pt',
      },
      {
        name: 'Guinea-Bissau Creole',
        code: null,
      },
    ],
    tz: [
      {
        name: 'Greenwich Mean Time',
        code: 'GMT',
        gmtOffset: '+0',
      },
      {
        name: 'Greenwich Mean Time',
        code: 'GMT',
        gmtOffset: '+0',
      },
    ],
    dst: false,
  },
  {
    key: 'GY',
    value: 'Guyana',
    code: {
      a2: 'GY',
      a3: 'GUY',
    },
    shortList: 'x',
    houseNumber: false,
    state: false,
    parent: null,
    depType: null,
    stateTerm: null,
    currency: {
      code: 'GYD',
      name: 'Guyanese Dollar',
      symbol: '$',
    },
    num: 328,
    dialingCode: 592,
    langs: [
      {
        name: 'English',
        code: 'en',
      },
    ],
    tz: [
      {
        name: 'Guyana Time',
        code: 'GYT',
        gmtOffset: -4,
      },
      {
        name: 'Guyana Time',
        code: 'GYT',
        gmtOffset: -4,
      },
    ],
    dst: false,
  },
  {
    key: 'HK',
    value: 'Hong Kong',
    code: {
      a2: 'HK',
      a3: 'HKG',
    },
    shortList: null,
    houseNumber: false,
    state: false,
    parent: 'CN',
    depType: 'dependent',
    stateTerm: null,
    currency: {
      code: 'HKD',
      name: 'Hong Kong Dollar',
      symbol: '$',
    },
    num: 344,
    dialingCode: 852,
    langs: [
      {
        name: 'Cantonese',
        code: null,
      },
      {
        name: 'English',
        code: 'en',
      },
    ],
    tz: [
      {
        name: 'Hong Kong Time',
        code: 'HKT',
        gmtOffset: '+8',
      },
      {
        name: 'Hong Kong Time',
        code: 'HKT',
        gmtOffset: '+8',
      },
    ],
    dst: false,
  },
  {
    key: 'HM',
    value: 'Heard Island and McDonald Islands',
    code: {
      a2: 'HM',
      a3: 'HMD',
    },
    shortList: null,
    houseNumber: false,
    state: false,
    parent: 'AU',
    depType: 'dependent',
    stateTerm: null,
    currency: {
      code: 'AUD',
      name: 'Australian Dollar',
      symbol: '$',
    },
    num: 334,
    dialingCode: 672,
    langs: [
      {
        name: 'English',
        code: 'en',
      },
    ],
    tz: [
      {
        name: 'Maldives Time',
        code: 'MVT',
        gmtOffset: '+5',
      },
      {
        name: 'Maldives Time',
        code: 'MVT',
        gmtOffset: '+5',
      },
    ],
    dst: false,
  },
  {
    key: 'HN',
    value: 'Honduras',
    code: {
      a2: 'HN',
      a3: 'HND',
    },
    shortList: 'x',
    houseNumber: false,
    state: false,
    parent: null,
    depType: null,
    stateTerm: null,
    currency: {
      code: 'HNL',
      name: 'Honduran Lempira',
      symbol: 'L',
    },
    num: 340,
    dialingCode: 504,
    langs: [
      {
        name: 'Spanish',
        code: 'es',
      },
    ],
    tz: [
      {
        name: 'Central Standard Time',
        code: 'CST',
        gmtOffset: -6,
      },
      {
        name: 'Central Standard Time',
        code: 'CST',
        gmtOffset: -6,
      },
    ],
    dst: false,
  },
  {
    key: 'HR',
    value: 'Croatia',
    code: {
      a2: 'HR',
      a3: 'HRV',
    },
    shortList: 'x',
    houseNumber: false,
    state: false,
    parent: null,
    depType: null,
    stateTerm: null,
    currency: {
      code: 'HRK',
      name: 'Croatian Kuna',
      symbol: 'kn',
    },
    num: 191,
    dialingCode: 385,
    langs: [
      {
        name: 'Croatian',
        code: 'hr',
      },
    ],
    tz: [
      {
        name: 'Central European Time',
        code: 'CET',
        gmtOffset: '+1',
      },
      {
        name: 'Central European Time',
        code: 'CET',
        gmtOffset: '+1',
      },
    ],
    dst: true,
  },
  {
    key: 'HT',
    value: 'Haiti',
    code: {
      a2: 'HT',
      a3: 'HTI',
    },
    shortList: 'x',
    houseNumber: false,
    state: false,
    parent: null,
    depType: null,
    stateTerm: null,
    currency: {
      code: 'HTG',
      name: 'Haitian Gourde',
      symbol: null,
    },
    num: 332,
    dialingCode: 509,
    langs: [
      {
        name: 'Haitian Creole',
        code: 'ht',
      },
      {
        name: 'French',
        code: 'fr',
      },
    ],
    tz: [
      {
        name: 'Eastern Standard Time',
        code: 'EST',
        gmtOffset: -5,
      },
      {
        name: 'Eastern Standard Time',
        code: 'EST',
        gmtOffset: -5,
      },
    ],
    dst: true,
  },
  {
    key: 'HU',
    value: 'Hungary',
    code: {
      a2: 'HU',
      a3: 'HUN',
    },
    shortList: 'x',
    houseNumber: true,
    parent: null,
    depType: null,
    stateTerm: null,
    currency: {
      code: 'HUF',
      name: 'Hungarian Forint',
      symbol: 'Ft',
    },
    num: 348,
    dialingCode: 36,
    langs: [
      {
        name: 'Hungarian',
        code: 'hu',
      },
    ],
    tz: [
      {
        name: 'Central European Time',
        code: 'CET',
        gmtOffset: '+1',
      },
      {
        name: 'Central European Time',
        code: 'CET',
        gmtOffset: '+1',
      },
    ],
    dst: true,
  },
  {
    key: 'ID',
    value: 'Indonesia',
    code: {
      a2: 'ID',
      a3: 'IDN',
    },
    shortList: 'x',
    houseNumber: false,
    state: true,
    parent: null,
    depType: null,
    stateTerm: 'provinces',
    currency: {
      code: 'IDR',
      name: 'Indonesian Rupiah',
      symbol: 'Rp',
    },
    num: 360,
    dialingCode: 62,
    langs: [
      {
        name: 'Indonesian',
        code: 'id',
      },
    ],
    tz: [
      {
        name: 'Western Indonesian Time',
        code: 'WIB',
        gmtOffset: '+7',
      },
      {
        name: 'Eastern Indonesian Time',
        code: 'WIT',
        gmtOffset: '+9',
      },
    ],
    dst: false,
  },
  {
    key: 'IE',
    value: 'Ireland',
    code: {
      a2: 'IE',
      a3: 'IRL',
    },
    shortList: 'x',
    houseNumber: false,
    state: false,
    parent: null,
    depType: null,
    stateTerm: null,
    currency: {
      code: 'EUR',
      name: 'Euro',
      symbol: '€',
    },
    num: 372,
    dialingCode: 353,
    langs: [
      {
        name: 'English',
        code: 'en',
      },
      {
        name: 'Irish',
        code: 'ga',
      },
    ],
    tz: [
      {
        name: 'Greenwich Mean Time',
        code: 'GMT',
        gmtOffset: '+0',
      },
      {
        name: 'Greenwich Mean Time',
        code: 'GMT',
        gmtOffset: '+0',
      },
    ],
    dst: true,
  },
  {
    key: 'IL',
    value: 'Israel',
    code: {
      a2: 'IL',
      a3: 'ISR',
    },
    shortList: 'x',
    houseNumber: false,
    state: false,
    parent: null,
    depType: null,
    stateTerm: null,
    currency: {
      code: 'ILS',
      name: 'New Israeli Shekel',
      symbol: '₪',
    },
    num: 376,
    dialingCode: 972,
    langs: [
      {
        name: 'Hebrew',
        code: 'he',
      },
      {
        name: 'Arabic',
        code: 'ar',
      },
    ],
    tz: [
      {
        name: 'Israel Standard Time',
        code: 'IST',
        gmtOffset: '+2',
      },
      {
        name: 'Israel Standard Time',
        code: 'IST',
        gmtOffset: '+2',
      },
    ],
    dst: true,
  },
  {
    key: 'IM',
    value: 'Isle of Man',
    code: {
      a2: 'IM',
      a3: 'IMN',
    },
    shortList: null,
    houseNumber: false,
    state: false,
    parent: 'GB',
    depType: 'dependent',
    stateTerm: null,
    currency: {
      code: 'GBP',
      name: 'Pound Sterling',
      symbol: '£',
    },
    num: 833,
    dialingCode: 44,
    langs: [
      {
        name: 'English',
        code: 'en',
      },
      {
        name: 'Manx',
        code: 'gv',
      },
    ],
    tz: [
      {
        name: 'Greenwich Mean Time',
        code: 'GMT',
        gmtOffset: '+0',
      },
      {
        name: 'Greenwich Mean Time',
        code: 'GMT',
        gmtOffset: '+0',
      },
    ],
    dst: true,
  },
  {
    key: 'IN',
    value: 'India',
    code: {
      a2: 'IN',
      a3: 'IND',
    },
    shortList: 'x',
    houseNumber: false,
    state: true,
    parent: null,
    depType: null,
    stateTerm: 'stateProvince',
    currency: {
      code: 'INR',
      name: 'Indian Rupee',
      symbol: '₹',
    },
    num: 356,
    dialingCode: 91,
    langs: [
      {
        name: 'Hindi',
        code: 'hi',
      },
      {
        name: 'English',
        code: 'en',
      },
    ],
    tz: [
      {
        name: 'India Standard Time',
        code: 'IST',
        gmtOffset: '+5.5',
      },
      {
        name: 'India Standard Time',
        code: 'IST',
        gmtOffset: '+5.5',
      },
    ],
    dst: false,
  },
  {
    key: 'IO',
    value: 'British Indian Ocean Territory',
    code: {
      a2: 'IO',
      a3: 'IOT',
    },
    shortList: null,
    houseNumber: false,
    state: false,
    parent: 'GB',
    depType: 'dependent',
    stateTerm: null,
    currency: {
      code: 'USD',
      name: 'US Dollar',
      symbol: '$',
    },
    num: 86,
    dialingCode: 246,
    langs: [
      {
        name: 'English',
        code: 'en',
      },
    ],
    tz: [
      {
        name: 'Indian Ocean Time',
        code: 'IOT',
        gmtOffset: '+6',
      },
      {
        name: 'Indian Ocean Time',
        code: 'IOT',
        gmtOffset: '+6',
      },
    ],
    dst: false,
  },
  {
    key: 'IQ',
    value: 'Iraq',
    code: {
      a2: 'IQ',
      a3: 'IRQ',
    },
    shortList: 'x',
    houseNumber: false,
    state: false,
    parent: null,
    depType: null,
    stateTerm: null,
    currency: {
      code: 'IQD',
      name: 'Iraqi Dinar',
      symbol: 'ع.د',
    },
    num: 368,
    dialingCode: 964,
    langs: [
      {
        name: 'Arabic',
        code: 'ar',
      },
      {
        name: 'Kurdish',
        code: 'ku',
      },
    ],
    tz: [
      {
        name: 'Arabia Standard Time',
        code: 'AST',
        gmtOffset: '+3',
      },
      {
        name: 'Arabia Standard Time',
        code: 'AST',
        gmtOffset: '+3',
      },
    ],
    dst: false,
  },
  {
    key: 'IR',
    value: 'Iran',
    code: {
      a2: 'IR',
      a3: 'IRN',
    },
    shortList: 'x',
    houseNumber: false,
    state: false,
    parent: null,
    depType: null,
    stateTerm: null,
    currency: {
      code: 'IRR',
      name: 'Iranian Rial',
      symbol: '﷼',
    },
    num: 364,
    dialingCode: 98,
    langs: [
      {
        name: 'Persian',
        code: 'fa',
      },
    ],
    tz: [
      {
        name: 'Iran Standard Time',
        code: 'IRST',
        gmtOffset: '+3.5',
      },
      {
        name: 'Iran Standard Time',
        code: 'IRST',
        gmtOffset: '+3.5',
      },
    ],
    dst: true,
  },
  {
    key: 'IS',
    value: 'Iceland',
    code: {
      a2: 'IS',
      a3: 'ISL',
    },
    shortList: 'x',
    houseNumber: false,
    state: false,
    parent: null,
    depType: null,
    stateTerm: null,
    currency: {
      code: 'ISK',
      name: 'Icelandic Króna',
      symbol: 'kr',
    },
    num: 352,
    dialingCode: 354,
    langs: [
      {
        name: 'Icelandic',
        code: 'is',
      },
    ],
    tz: [
      {
        name: 'Greenwich Mean Time',
        code: 'GMT',
        gmtOffset: '+0',
      },
      {
        name: 'Greenwich Mean Time',
        code: 'GMT',
        gmtOffset: '+0',
      },
    ],
    dst: false,
  },
  {
    key: 'IT',
    value: 'Italy',
    code: {
      a2: 'IT',
      a3: 'ITA',
    },
    shortList: 'x',
    houseNumber: false,
    state: true,
    parent: null,
    depType: null,
    stateTerm: 'region',
    currency: {
      code: 'EUR',
      name: 'Euro',
      symbol: '€',
    },
    num: 380,
    dialingCode: 39,
    langs: [
      {
        name: 'Italian',
        code: 'it',
      },
    ],
    tz: [
      {
        name: 'Central European Time',
        code: 'CET',
        gmtOffset: '+1',
      },
      {
        name: 'Central European Time',
        code: 'CET',
        gmtOffset: '+1',
      },
    ],
    dst: true,
  },
  {
    key: 'JE',
    value: 'Jersey',
    code: {
      a2: 'JE',
      a3: 'JEY',
    },
    shortList: null,
    houseNumber: false,
    state: false,
    parent: 'GB',
    depType: 'dependent',
    stateTerm: null,
    currency: {
      code: 'GBP',
      name: 'Pound Sterling',
      symbol: '£',
    },
    num: 832,
    dialingCode: 44,
    langs: [
      {
        name: 'English',
        code: 'en',
      },
      {
        name: 'Jèrriais',
        code: null,
      },
    ],
    tz: [
      {
        name: 'Greenwich Mean Time',
        code: 'GMT',
        gmtOffset: '+0',
      },
      {
        name: 'Greenwich Mean Time',
        code: 'GMT',
        gmtOffset: '+0',
      },
    ],
    dst: true,
  },
  {
    key: 'JM',
    value: 'Jamaica',
    code: {
      a2: 'JM',
      a3: 'JAM',
    },
    shortList: 'x',
    houseNumber: false,
    state: false,
    parent: null,
    depType: null,
    stateTerm: null,
    currency: {
      code: 'JMD',
      name: 'Jamaican Dollar',
      symbol: 'J$',
    },
    num: 388,
    dialingCode: '1-876',
    langs: [
      {
        name: 'English',
        code: 'en',
      },
    ],
    tz: [
      {
        name: 'Eastern Standard Time',
        code: 'EST',
        gmtOffset: -5,
      },
      {
        name: 'Eastern Standard Time',
        code: 'EST',
        gmtOffset: -5,
      },
    ],
    dst: false,
  },
  {
    key: 'JO',
    value: 'Jordan',
    code: {
      a2: 'JO',
      a3: 'JOR',
    },
    shortList: 'x',
    houseNumber: false,
    state: false,
    parent: null,
    depType: null,
    stateTerm: null,
    currency: {
      code: 'JOD',
      name: 'Jordanian Dinar',
      symbol: 'د.ا',
    },
    num: 400,
    dialingCode: 962,
    langs: [
      {
        name: 'Arabic',
        code: 'ar',
      },
    ],
    tz: [
      {
        name: 'Eastern European Time',
        code: 'EET',
        gmtOffset: '+2',
      },
      {
        name: 'Eastern European Time',
        code: 'EET',
        gmtOffset: '+2',
      },
    ],
    dst: true,
  },
  {
    key: 'JP',
    value: 'Japan',
    code: {
      a2: 'JP',
      a3: 'JPN',
    },
    shortList: 'x',
    houseNumber: false,
    state: true,
    parent: null,
    depType: null,
    stateTerm: 'prefecture',
    currency: {
      code: 'JPY',
      name: 'Japanese Yen',
      symbol: '¥',
    },
    num: 392,
    dialingCode: 81,
    langs: [
      {
        name: 'Japanese',
        code: 'ja',
      },
    ],
    tz: [
      {
        name: 'Japan Standard Time',
        code: 'JST',
        gmtOffset: '+9',
      },
      {
        name: 'Japan Standard Time',
        code: 'JST',
        gmtOffset: '+9',
      },
    ],
    dst: false,
  },
  {
    key: 'KE',
    value: 'Kenya',
    code: {
      a2: 'KE',
      a3: 'KEN',
    },
    shortList: 'x',
    houseNumber: false,
    state: true,
    parent: null,
    depType: null,
    stateTerm: 'county',
    currency: {
      code: 'KES',
      name: 'Kenyan Shilling',
      symbol: 'KSh',
    },
    num: 404,
    dialingCode: 254,
    langs: [
      {
        name: 'Swahili',
        code: 'sw',
      },
      {
        name: 'English',
        code: 'en',
      },
    ],
    tz: [
      {
        name: 'East Africa Time',
        code: 'EAT',
        gmtOffset: '+3',
      },
      {
        name: 'East Africa Time',
        code: 'EAT',
        gmtOffset: '+3',
      },
    ],
    dst: false,
  },
  {
    key: 'KG',
    value: 'Kyrgyzstan',
    code: {
      a2: 'KG',
      a3: 'KGZ',
    },
    shortList: 'x',
    houseNumber: false,
    state: false,
    parent: null,
    depType: null,
    stateTerm: null,
    currency: {
      code: 'KGS',
      name: 'Kyrgyzstani Som',
      symbol: 'сом',
    },
    num: 417,
    dialingCode: 996,
    langs: [
      {
        name: 'Kyrgyz',
        code: 'ky',
      },
      {
        name: 'Russian',
        code: 'ru',
      },
    ],
    tz: [
      {
        name: 'Kyrgyzstan Time',
        code: 'KGT',
        gmtOffset: '+6',
      },
      {
        name: 'Kyrgyzstan Time',
        code: 'KGT',
        gmtOffset: '+6',
      },
    ],
    dst: false,
  },
  {
    key: 'KH',
    value: 'Cambodia',
    code: {
      a2: 'KH',
      a3: 'KHM',
    },
    shortList: 'x',
    houseNumber: false,
    state: false,
    parent: null,
    depType: null,
    stateTerm: null,
    currency: {
      code: 'KHR',
      name: 'Cambodian Riel',
      symbol: '៛',
    },
    num: 116,
    dialingCode: 855,
    langs: [
      {
        name: 'Khmer',
        code: 'km',
      },
    ],
    tz: [
      {
        name: 'Indochina Time',
        code: 'ICT',
        gmtOffset: '+7',
      },
      {
        name: 'Indochina Time',
        code: 'ICT',
        gmtOffset: '+7',
      },
    ],
    dst: false,
  },
  {
    key: 'KI',
    value: 'Kiribati',
    code: {
      a2: 'KI',
      a3: 'KIR',
    },
    shortList: 'x',
    houseNumber: false,
    state: false,
    parent: null,
    depType: null,
    stateTerm: null,
    currency: {
      code: 'AUD',
      name: 'Australian Dollar',
      symbol: '$',
    },
    num: 296,
    dialingCode: 686,
    langs: [
      {
        name: 'Gilbertese',
        code: null,
      },
      {
        name: 'English',
        code: 'en',
      },
    ],
    tz: [
      {
        name: 'Gilbert Island Time',
        code: 'GILT',
        gmtOffset: '+12',
      },
      {
        name: 'Line Islands Time',
        code: 'LINT',
        gmtOffset: '+14',
      },
    ],
    dst: false,
  },
  {
    key: 'KM',
    value: 'Comoros',
    code: {
      a2: 'KM',
      a3: 'COM',
    },
    shortList: 'x',
    houseNumber: false,
    state: false,
    parent: null,
    depType: null,
    stateTerm: null,
    currency: {
      code: 'KMF',
      name: 'Comorian Franc',
      symbol: null,
    },
    num: 174,
    dialingCode: 269,
    langs: [
      {
        name: 'Comorian',
        code: null,
      },
      {
        name: 'Arabic',
        code: 'ar',
      },
      {
        name: 'French',
        code: 'fr',
      },
    ],
    tz: [
      {
        name: 'East Africa Time',
        code: 'EAT',
        gmtOffset: '+3',
      },
      {
        name: 'East Africa Time',
        code: 'EAT',
        gmtOffset: '+3',
      },
    ],
    dst: false,
  },
  {
    key: 'KN',
    value: 'Saint Kitts and Nevis',
    code: {
      a2: 'KN',
      a3: 'KNA',
    },
    shortList: 'x',
    houseNumber: false,
    state: false,
    parent: null,
    depType: null,
    stateTerm: null,
    currency: {
      code: 'XCD',
      name: 'East Caribbean Dollar',
      symbol: null,
    },
    num: 659,
    dialingCode: '1-869',
    langs: [
      {
        name: 'English',
        code: 'en',
      },
    ],
    tz: [
      {
        name: 'Atlantic Standard Time',
        code: 'AST',
        gmtOffset: -4,
      },
      {
        name: 'Atlantic Standard Time',
        code: 'AST',
        gmtOffset: -4,
      },
    ],
    dst: false,
  },
  {
    key: 'KP',
    value: 'North Korea',
    code: {
      a2: 'KP',
      a3: 'PRK',
    },
    shortList: 'x',
    houseNumber: false,
    state: false,
    parent: null,
    depType: null,
    stateTerm: null,
    currency: {
      code: 'KPW',
      name: 'North Korean Won',
      symbol: '₩',
    },
    num: 408,
    dialingCode: 850,
    langs: [
      {
        name: 'Korean',
        code: 'ko',
      },
    ],
    tz: [
      {
        name: 'Korea Standard Time',
        code: 'KST',
        gmtOffset: '+9',
      },
      {
        name: 'Korea Standard Time',
        code: 'KST',
        gmtOffset: '+9',
      },
    ],
    dst: false,
  },
  {
    key: 'KR',
    value: 'South Korea',
    code: {
      a2: 'KR',
      a3: 'KOR',
    },
    shortList: 'x',
    houseNumber: false,
    state: false,
    parent: null,
    depType: null,
    stateTerm: null,
    currency: {
      code: 'KRW',
      name: 'South Korean Won',
      symbol: '₩',
    },
    num: 410,
    dialingCode: 82,
    langs: [
      {
        name: 'Korean',
        code: 'ko',
      },
    ],
    tz: [
      {
        name: 'Korea Standard Time',
        code: 'KST',
        gmtOffset: '+9',
      },
      {
        name: 'Korea Standard Time',
        code: 'KST',
        gmtOffset: '+9',
      },
    ],
    dst: false,
  },
  {
    key: 'KW',
    value: 'Kuwait',
    code: {
      a2: 'KW',
      a3: 'KWT',
    },
    shortList: 'x',
    houseNumber: false,
    state: false,
    parent: null,
    depType: null,
    stateTerm: null,
    currency: {
      code: 'KWD',
      name: 'Kuwaiti Dinar',
      symbol: 'د.ك',
    },
    num: 414,
    dialingCode: 965,
    langs: [
      {
        name: 'Arabic',
        code: 'ar',
      },
    ],
    tz: [
      {
        name: 'Arabia Standard Time',
        code: 'AST',
        gmtOffset: '+3',
      },
      {
        name: 'Arabia Standard Time',
        code: 'AST',
        gmtOffset: '+3',
      },
    ],
    dst: false,
  },
  {
    key: 'KY',
    value: 'Cayman Islands',
    code: {
      a2: 'KY',
      a3: 'CYM',
    },
    shortList: null,
    houseNumber: false,
    state: false,
    parent: 'GB',
    depType: 'dependent',
    stateTerm: null,
    currency: {
      code: 'KYD',
      name: 'Cayman Islands Dollar',
      symbol: '$',
    },
    num: 136,
    dialingCode: '1-345',
    langs: [
      {
        name: 'English',
        code: 'en',
      },
    ],
    tz: [
      {
        name: 'Eastern Standard Time',
        code: 'EST',
        gmtOffset: -5,
      },
      {
        name: 'Eastern Standard Time',
        code: 'EST',
        gmtOffset: -5,
      },
    ],
    dst: false,
  },
  {
    key: 'KZ',
    value: 'Kazakhstan',
    code: {
      a2: 'KZ',
      a3: 'KAZ',
    },
    shortList: 'x',
    houseNumber: false,
    state: false,
    parent: null,
    depType: null,
    stateTerm: null,
    currency: {
      code: 'KZT',
      name: 'Kazakhstani Tenge',
      symbol: '₸',
    },
    num: 398,
    dialingCode: 7,
    langs: [
      {
        name: 'Kazakh',
        code: 'kk',
      },
      {
        name: 'Russian',
        code: 'ru',
      },
    ],
    tz: [
      {
        name: 'Aqtobe Time',
        code: 'AQTT',
        gmtOffset: '+5',
      },
      {
        name: 'Almaty Time',
        code: 'ALMT',
        gmtOffset: '+6',
      },
    ],
    dst: false,
  },
  {
    key: 'LA',
    value: 'Laos',
    code: {
      a2: 'LA',
      a3: 'LAO',
    },
    shortList: 'x',
    houseNumber: false,
    state: false,
    parent: null,
    depType: null,
    stateTerm: null,
    currency: {
      code: 'LAK',
      name: 'Lao Kip',
      symbol: '₭',
    },
    num: 418,
    dialingCode: 856,
    langs: [
      {
        name: 'Lao',
        code: 'lo',
      },
    ],
    tz: [
      {
        name: 'Indochina Time',
        code: 'ICT',
        gmtOffset: '+7',
      },
      {
        name: 'Indochina Time',
        code: 'ICT',
        gmtOffset: '+7',
      },
    ],
    dst: false,
  },
  {
    key: 'LB',
    value: 'Lebanon',
    code: {
      a2: 'LB',
      a3: 'LBN',
    },
    shortList: 'x',
    houseNumber: false,
    state: false,
    parent: null,
    depType: null,
    stateTerm: null,
    currency: {
      code: 'LBP',
      name: 'Lebanese Pound',
      symbol: 'ل.ل',
    },
    num: 422,
    dialingCode: 961,
    langs: [
      {
        name: 'Arabic',
        code: 'ar',
      },
    ],
    tz: [
      {
        name: 'Eastern European Time',
        code: 'EET',
        gmtOffset: '+2',
      },
      {
        name: 'Eastern European Time',
        code: 'EET',
        gmtOffset: '+2',
      },
    ],
    dst: true,
  },
  {
    key: 'LC',
    value: 'Saint Lucia',
    code: {
      a2: 'LC',
      a3: 'LCA',
    },
    shortList: 'x',
    houseNumber: false,
    state: false,
    parent: null,
    depType: null,
    stateTerm: null,
    currency: {
      code: 'XCD',
      name: 'East Caribbean Dollar',
      symbol: null,
    },
    num: 662,
    dialingCode: '1-758',
    langs: [
      {
        name: 'English',
        code: 'en',
      },
    ],
    tz: [
      {
        name: 'Atlantic Standard Time',
        code: 'AST',
        gmtOffset: -4,
      },
      {
        name: 'Atlantic Standard Time',
        code: 'AST',
        gmtOffset: -4,
      },
    ],
    dst: false,
  },
  {
    key: 'LI',
    value: 'Liechtenstein',
    code: {
      a2: 'LI',
      a3: 'LIE',
    },
    shortList: 'x',
    houseNumber: false,
    state: false,
    parent: null,
    depType: null,
    stateTerm: null,
    currency: {
      code: 'CHF',
      name: 'Swiss Franc',
      symbol: 'CHF',
    },
    num: 438,
    dialingCode: 423,
    langs: [
      {
        name: 'German',
        code: 'de',
      },
    ],
    tz: [
      {
        name: 'Central European Time',
        code: 'CET',
        gmtOffset: '+1',
      },
      {
        name: 'Central European Time',
        code: 'CET',
        gmtOffset: '+1',
      },
    ],
    dst: true,
  },
  {
    key: 'LK',
    value: 'Sri Lanka',
    code: {
      a2: 'LK',
      a3: 'LKA',
    },
    shortList: 'x',
    houseNumber: false,
    state: false,
    parent: null,
    depType: null,
    stateTerm: null,
    currency: {
      code: 'LKR',
      name: 'Sri Lankan Rupee',
      symbol: 'Rs',
    },
    num: 144,
    dialingCode: 94,
    langs: [
      {
        name: 'Sinhala',
        code: 'si',
      },
      {
        name: 'Tamil',
        code: 'ta',
      },
    ],
    tz: [
      {
        name: 'Sri Lanka Standard Time',
        code: 'SLST',
        gmtOffset: '+5.5',
      },
      {
        name: 'Sri Lanka Standard Time',
        code: 'SLST',
        gmtOffset: '+5.5',
      },
    ],
    dst: false,
  },
  {
    key: 'LR',
    value: 'Liberia',
    code: {
      a2: 'LR',
      a3: 'LBR',
    },
    shortList: 'x',
    houseNumber: false,
    state: false,
    parent: null,
    depType: null,
    stateTerm: null,
    currency: {
      code: 'LRD',
      name: 'Liberian Dollar',
      symbol: '$',
    },
    num: 430,
    dialingCode: 231,
    langs: [
      {
        name: 'English',
        code: 'en',
      },
    ],
    tz: [
      {
        name: 'Greenwich Mean Time',
        code: 'GMT',
        gmtOffset: '+0',
      },
      {
        name: 'Greenwich Mean Time',
        code: 'GMT',
        gmtOffset: '+0',
      },
    ],
    dst: false,
  },
  {
    key: 'LS',
    value: 'Lesotho',
    code: {
      a2: 'LS',
      a3: 'LSO',
    },
    shortList: 'x',
    houseNumber: false,
    state: false,
    parent: null,
    depType: null,
    stateTerm: null,
    currency: {
      code: 'LSL',
      name: 'Lesotho Loti',
      symbol: 'L',
    },
    num: 426,
    dialingCode: 266,
    langs: [
      {
        name: 'Sesotho',
        code: 'st',
      },
      {
        name: 'English',
        code: 'en',
      },
    ],
    tz: [
      {
        name: 'South Africa Standard Time',
        code: 'SAST',
        gmtOffset: '+2',
      },
      {
        name: 'South Africa Standard Time',
        code: 'SAST',
        gmtOffset: '+2',
      },
    ],
    dst: false,
  },
  {
    key: 'LT',
    value: 'Lithuania',
    code: {
      a2: 'LT',
      a3: 'LTU',
    },
    shortList: 'x',
    houseNumber: false,
    state: false,
    parent: null,
    depType: null,
    stateTerm: null,
    currency: {
      code: 'EUR',
      name: 'Euro',
      symbol: '€',
    },
    num: 440,
    dialingCode: 370,
    langs: [
      {
        name: 'Lithuanian',
        code: 'lt',
      },
    ],
    tz: [
      {
        name: 'Eastern European Time',
        code: 'EET',
        gmtOffset: '+2',
      },
      {
        name: 'Eastern European Time',
        code: 'EET',
        gmtOffset: '+2',
      },
    ],
    dst: true,
  },
  {
    key: 'LU',
    value: 'Luxembourg',
    code: {
      a2: 'LU',
      a3: 'LUX',
    },
    shortList: 'x',
    houseNumber: false,
    state: false,
    parent: null,
    depType: null,
    stateTerm: null,
    currency: {
      code: 'EUR',
      name: 'Euro',
      symbol: '€',
    },
    num: 442,
    dialingCode: 352,
    langs: [
      {
        name: 'Luxembourgish',
        code: 'lb',
      },
      {
        name: 'French',
        code: 'fr',
      },
      {
        name: 'German',
        code: 'de',
      },
    ],
    tz: [
      {
        name: 'Central European Time',
        code: 'CET',
        gmtOffset: '+1',
      },
      {
        name: 'Central European Time',
        code: 'CET',
        gmtOffset: '+1',
      },
    ],
    dst: true,
  },
  {
    key: 'LV',
    value: 'Latvia',
    code: {
      a2: 'LV',
      a3: 'LVA',
    },
    shortList: 'x',
    houseNumber: false,
    state: false,
    parent: null,
    depType: null,
    stateTerm: null,
    currency: {
      code: 'EUR',
      name: 'Euro',
      symbol: '€',
    },
    num: 428,
    dialingCode: 371,
    langs: [
      {
        name: 'Latvian',
        code: 'lv',
      },
    ],
    tz: [
      {
        name: 'Eastern European Time',
        code: 'EET',
        gmtOffset: '+2',
      },
      {
        name: 'Eastern European Time',
        code: 'EET',
        gmtOffset: '+2',
      },
    ],
    dst: true,
  },
  {
    key: 'LY',
    value: 'Libya',
    code: {
      a2: 'LY',
      a3: 'LBY',
    },
    shortList: 'x',
    houseNumber: false,
    state: false,
    parent: null,
    depType: null,
    stateTerm: null,
    currency: {
      code: 'LYD',
      name: 'Libyan Dinar',
      symbol: 'ل.د',
    },
    num: 434,
    dialingCode: 218,
    langs: [
      {
        name: 'Arabic',
        code: 'ar',
      },
    ],
    tz: [
      {
        name: 'Eastern European Time',
        code: 'EET',
        gmtOffset: '+2',
      },
      {
        name: 'Eastern European Time',
        code: 'EET',
        gmtOffset: '+2',
      },
    ],
    dst: false,
  },
  {
    key: 'MA',
    value: 'Morocco',
    code: {
      a2: 'MA',
      a3: 'MAR',
    },
    shortList: 'x',
    houseNumber: false,
    state: false,
    parent: null,
    depType: null,
    stateTerm: null,
    currency: {
      code: 'MAD',
      name: 'Moroccan Dirham',
      symbol: 'د.م',
    },
    num: 504,
    dialingCode: 212,
    langs: [
      {
        name: 'Arabic',
        code: 'ar',
      },
      {
        name: 'Berber',
        code: null,
      },
    ],
    tz: [
      {
        name: 'Western European Time',
        code: 'WET',
        gmtOffset: '+0',
      },
      {
        name: 'Western European Time',
        code: 'WET',
        gmtOffset: '+0',
      },
    ],
    dst: true,
  },
  {
    key: 'MC',
    value: 'Monaco',
    code: {
      a2: 'MC',
      a3: 'MCO',
    },
    shortList: 'x',
    houseNumber: false,
    state: false,
    parent: null,
    depType: null,
    stateTerm: null,
    currency: {
      code: 'EUR',
      name: 'Euro',
      symbol: '€',
    },
    num: 492,
    dialingCode: 377,
    langs: [
      {
        name: 'French',
        code: 'fr',
      },
    ],
    tz: [
      {
        name: 'Central European Time',
        code: 'CET',
        gmtOffset: '+1',
      },
      {
        name: 'Central European Time',
        code: 'CET',
        gmtOffset: '+1',
      },
    ],
    dst: true,
  },
  {
    key: 'MD',
    value: 'Moldova',
    code: {
      a2: 'MD',
      a3: 'MDA',
    },
    shortList: 'x',
    houseNumber: false,
    state: false,
    parent: null,
    depType: null,
    stateTerm: null,
    currency: {
      code: 'MDL',
      name: 'Moldovan Leu',
      symbol: 'L',
    },
    num: 498,
    dialingCode: 373,
    langs: [
      {
        name: 'Romanian',
        code: 'ro',
      },
    ],
    tz: [
      {
        name: 'Eastern European Time',
        code: 'EET',
        gmtOffset: '+2',
      },
      {
        name: 'Eastern European Time',
        code: 'EET',
        gmtOffset: '+2',
      },
    ],
    dst: true,
  },
  {
    key: 'ME',
    value: 'Montenegro',
    code: {
      a2: 'ME',
      a3: 'MNE',
    },
    shortList: 'x',
    houseNumber: false,
    state: false,
    parent: null,
    depType: null,
    stateTerm: null,
    currency: {
      code: 'EUR',
      name: 'Euro',
      symbol: '€',
    },
    num: 499,
    dialingCode: 382,
    langs: [
      {
        name: 'Montenegrin',
        code: null,
      },
    ],
    tz: [
      {
        name: 'Central European Time',
        code: 'CET',
        gmtOffset: '+1',
      },
      {
        name: 'Central European Time',
        code: 'CET',
        gmtOffset: '+1',
      },
    ],
    dst: true,
  },
  {
    key: 'MF',
    value: 'Saint Martin (French part)',
    code: {
      a2: 'MF',
      a3: 'MAF',
    },
    shortList: null,
    houseNumber: false,
    state: false,
    parent: 'FR',
    depType: 'dependent',
    stateTerm: null,
    currency: {
      code: 'EUR',
      name: 'Euro',
      symbol: '€',
    },
    num: 663,
    dialingCode: 590,
    langs: [
      {
        name: 'French',
        code: 'fr',
      },
    ],
    tz: [
      {
        name: 'Atlantic Standard Time',
        code: 'AST',
        gmtOffset: -4,
      },
      {
        name: 'Atlantic Standard Time',
        code: 'AST',
        gmtOffset: -4,
      },
    ],
    dst: false,
  },
  {
    key: 'MG',
    value: 'Madagascar',
    code: {
      a2: 'MG',
      a3: 'MDG',
    },
    shortList: 'x',
    houseNumber: false,
    state: false,
    parent: null,
    depType: null,
    stateTerm: null,
    currency: {
      code: 'MGA',
      name: 'Malagasy Ariary',
      symbol: 'Ar',
    },
    num: 450,
    dialingCode: 261,
    langs: [
      {
        name: 'Malagasy',
        code: 'mg',
      },
      {
        name: 'French',
        code: 'fr',
      },
    ],
    tz: [
      {
        name: 'East Africa Time',
        code: 'EAT',
        gmtOffset: '+3',
      },
      {
        name: 'East Africa Time',
        code: 'EAT',
        gmtOffset: '+3',
      },
    ],
    dst: false,
  },
  {
    key: 'MH',
    value: 'Marshall Islands',
    code: {
      a2: 'MH',
      a3: 'MHL',
    },
    shortList: 'x',
    houseNumber: false,
    state: false,
    parent: null,
    depType: null,
    stateTerm: null,
    currency: {
      code: 'USD',
      name: 'US Dollar',
      symbol: '$',
    },
    num: 584,
    dialingCode: 692,
    langs: [
      {
        name: 'Marshallese',
        code: 'mh',
      },
      {
        name: 'English',
        code: 'en',
      },
    ],
    tz: [
      {
        name: 'Marshall Islands Time',
        code: 'MHT',
        gmtOffset: '+12',
      },
      {
        name: 'Marshall Islands Time',
        code: 'MHT',
        gmtOffset: '+12',
      },
    ],
    dst: false,
  },
  {
    key: 'MK',
    value: 'North Macedonia',
    code: {
      a2: 'MK',
      a3: 'MKD',
    },
    shortList: 'x',
    houseNumber: false,
    state: false,
    parent: null,
    depType: null,
    stateTerm: null,
    currency: {
      code: 'MKD',
      name: 'Macedonian Denar',
      symbol: 'ден',
    },
    num: 807,
    dialingCode: 389,
    langs: [
      {
        name: 'Macedonian',
        code: 'mk',
      },
      {
        name: 'Albanian',
        code: 'sq',
      },
    ],
    tz: [
      {
        name: 'Central European Time',
        code: 'CET',
        gmtOffset: '+1',
      },
      {
        name: 'Central European Time',
        code: 'CET',
        gmtOffset: '+1',
      },
    ],
    dst: true,
  },
  {
    key: 'ML',
    value: 'Mali',
    code: {
      a2: 'ML',
      a3: 'MLI',
    },
    shortList: 'x',
    houseNumber: false,
    state: false,
    parent: null,
    depType: null,
    stateTerm: null,
    currency: {
      code: 'XOF',
      name: 'West African CFA franc',
      symbol: null,
    },
    num: 466,
    dialingCode: 223,
    langs: [
      {
        name: 'French',
        code: 'fr',
      },
      {
        name: 'Bambara',
        code: 'bm',
      },
    ],
    tz: [
      {
        name: 'Greenwich Mean Time',
        code: 'GMT',
        gmtOffset: '+0',
      },
      {
        name: 'Greenwich Mean Time',
        code: 'GMT',
        gmtOffset: '+0',
      },
    ],
    dst: false,
  },
  {
    key: 'MM',
    value: 'Myanmar',
    code: {
      a2: 'MM',
      a3: 'MMR',
    },
    shortList: 'x',
    houseNumber: false,
    state: false,
    parent: null,
    depType: null,
    stateTerm: null,
    currency: {
      code: 'MMK',
      name: 'Burmese Kyat',
      symbol: 'K',
    },
    num: 104,
    dialingCode: 95,
    langs: [
      {
        name: 'Burmese',
        code: 'my',
      },
    ],
    tz: [
      {
        name: 'Myanmar Time',
        code: 'MMT',
        gmtOffset: '+6.5',
      },
      {
        name: 'Myanmar Time',
        code: 'MMT',
        gmtOffset: '+6.5',
      },
    ],
    dst: false,
  },
  {
    key: 'MN',
    value: 'Mongolia',
    code: {
      a2: 'MN',
      a3: 'MNG',
    },
    shortList: 'x',
    houseNumber: false,
    state: false,
    parent: null,
    depType: null,
    stateTerm: null,
    currency: {
      code: 'MNT',
      name: 'Mongolian Tögrög',
      symbol: '₮',
    },
    num: 496,
    dialingCode: 976,
    langs: [
      {
        name: 'Mongolian',
        code: 'mn',
      },
    ],
    tz: [
      {
        name: 'Western Mongolia Standard Time',
        code: 'WAST',
        gmtOffset: '+7',
      },
      {
        name: 'Ulaanbaatar Time',
        code: 'ULAT',
        gmtOffset: '+8',
      },
    ],
    dst: false,
  },
  {
    key: 'MO',
    value: 'Macao',
    code: {
      a2: 'MO',
      a3: 'MAC',
    },
    shortList: null,
    houseNumber: false,
    state: false,
    parent: 'CN',
    depType: 'dependent',
    stateTerm: null,
    currency: {
      code: 'MOP',
      name: 'Macanese Pataca',
      symbol: 'P',
    },
    num: 446,
    dialingCode: 853,
    langs: [
      {
        name: 'Cantonese',
        code: null,
      },
      {
        name: 'Portuguese',
        code: 'pt',
      },
    ],
    tz: [
      {
        name: 'China Standard Time',
        code: 'CST',
        gmtOffset: '+8',
      },
      {
        name: 'China Standard Time',
        code: 'CST',
        gmtOffset: '+8',
      },
    ],
    dst: false,
  },
  {
    key: 'MP',
    value: 'Northern Mariana Islands',
    code: {
      a2: 'MP',
      a3: 'MNP',
    },
    shortList: null,
    houseNumber: false,
    state: false,
    parent: 'US',
    depType: 'dependent',
    stateTerm: null,
    currency: {
      code: 'USD',
      name: 'US Dollar',
      symbol: '$',
    },
    num: 580,
    dialingCode: '1-670',
    langs: [
      {
        name: 'Chamorro',
        code: 'ch',
      },
      {
        name: 'English',
        code: 'en',
      },
    ],
    tz: [
      {
        name: 'Chamorro Standard Time',
        code: 'ChST',
        gmtOffset: '+10',
      },
      {
        name: 'Chamorro Standard Time',
        code: 'ChST',
        gmtOffset: '+10',
      },
    ],
    dst: false,
  },
  {
    key: 'MQ',
    value: 'Martinique',
    code: {
      a2: 'MQ',
      a3: 'MTQ',
    },
    shortList: null,
    houseNumber: false,
    state: false,
    parent: 'FR',
    depType: 'dependent',
    stateTerm: null,
    currency: {
      code: 'EUR',
      name: 'Euro',
      symbol: '€',
    },
    num: 474,
    dialingCode: 596,
    langs: [
      {
        name: 'French',
        code: 'fr',
      },
    ],
    tz: [
      {
        name: 'Atlantic Standard Time',
        code: 'AST',
        gmtOffset: -4,
      },
      {
        name: 'Atlantic Standard Time',
        code: 'AST',
        gmtOffset: -4,
      },
    ],
    dst: false,
  },
  {
    key: 'MR',
    value: 'Mauritania',
    code: {
      a2: 'MR',
      a3: 'MRT',
    },
    shortList: 'x',
    houseNumber: false,
    state: false,
    parent: null,
    depType: null,
    stateTerm: null,
    currency: {
      code: 'MRU',
      name: 'Mauritanian Ouguiya',
      symbol: null,
    },
    num: 478,
    dialingCode: 222,
    langs: [
      {
        name: 'Arabic',
        code: 'ar',
      },
      {
        name: 'French',
        code: 'fr',
      },
    ],
    tz: [
      {
        name: 'Greenwich Mean Time',
        code: 'GMT',
        gmtOffset: '+0',
      },
      {
        name: 'Greenwich Mean Time',
        code: 'GMT',
        gmtOffset: '+0',
      },
    ],
    dst: false,
  },
  {
    key: 'MS',
    value: 'Montserrat',
    code: {
      a2: 'MS',
      a3: 'MSR',
    },
    shortList: null,
    houseNumber: false,
    state: false,
    parent: 'GB',
    depType: 'dependent',
    stateTerm: null,
    currency: {
      code: 'XCD',
      name: 'East Caribbean Dollar',
      symbol: null,
    },
    num: 500,
    dialingCode: '1-664',
    langs: [
      {
        name: 'English',
        code: 'en',
      },
    ],
    tz: [
      {
        name: 'Atlantic Standard Time',
        code: 'AST',
        gmtOffset: -4,
      },
      {
        name: 'Atlantic Standard Time',
        code: 'AST',
        gmtOffset: -4,
      },
    ],
    dst: false,
  },
  {
    key: 'MT',
    value: 'Malta',
    code: {
      a2: 'MT',
      a3: 'MLT',
    },
    shortList: 'x',
    houseNumber: false,
    state: false,
    parent: null,
    depType: null,
    stateTerm: null,
    currency: {
      code: 'EUR',
      name: 'Euro',
      symbol: '€',
    },
    num: 470,
    dialingCode: 356,
    langs: [
      {
        name: 'Maltese',
        code: 'mt',
      },
      {
        name: 'English',
        code: 'en',
      },
    ],
    tz: [
      {
        name: 'Central European Time',
        code: 'CET',
        gmtOffset: '+1',
      },
      {
        name: 'Central European Time',
        code: 'CET',
        gmtOffset: '+1',
      },
    ],
    dst: true,
  },
  {
    key: 'MU',
    value: 'Mauritius',
    code: {
      a2: 'MU',
      a3: 'MUS',
    },
    shortList: 'x',
    houseNumber: false,
    state: false,
    parent: null,
    depType: null,
    stateTerm: null,
    currency: {
      code: 'MUR',
      name: 'Mauritian Rupee',
      symbol: '₨',
    },
    num: 480,
    dialingCode: 230,
    langs: [
      {
        name: 'Mauritian Creole',
        code: 'mfe',
      },
      {
        name: 'English',
        code: 'en',
      },
      {
        name: 'French',
        code: 'fr',
      },
    ],
    tz: [
      {
        name: 'Mauritius Time',
        code: 'MUT',
        gmtOffset: '+4',
      },
      {
        name: 'Mauritius Time',
        code: 'MUT',
        gmtOffset: '+4',
      },
    ],
    dst: false,
  },
  {
    key: 'MV',
    value: 'Maldives',
    code: {
      a2: 'MV',
      a3: 'MDV',
    },
    shortList: 'x',
    houseNumber: false,
    state: false,
    parent: null,
    depType: null,
    stateTerm: null,
    currency: {
      code: 'MVR',
      name: 'Maldivian Rufiyaa',
      symbol: 'ރ',
    },
    num: 462,
    dialingCode: 960,
    langs: [
      {
        name: 'Dhivehi',
        code: 'dv',
      },
    ],
    tz: [
      {
        name: 'Maldives Time',
        code: 'MVT',
        gmtOffset: '+5',
      },
      {
        name: 'Maldives Time',
        code: 'MVT',
        gmtOffset: '+5',
      },
    ],
    dst: false,
  },
  {
    key: 'MW',
    value: 'Malawi',
    code: {
      a2: 'MW',
      a3: 'MWI',
    },
    shortList: 'x',
    houseNumber: false,
    state: false,
    parent: null,
    depType: null,
    stateTerm: null,
    currency: {
      code: 'MWK',
      name: 'Malawian Kwacha',
      symbol: null,
    },
    num: 454,
    dialingCode: 265,
    langs: [
      {
        name: 'Chichewa',
        code: 'ny',
      },
      {
        name: 'English',
        code: 'en',
      },
    ],
    tz: [
      {
        name: 'Central Africa Time',
        code: 'CAT',
        gmtOffset: '+2',
      },
      {
        name: 'Central Africa Time',
        code: 'CAT',
        gmtOffset: '+2',
      },
    ],
    dst: false,
  },
  {
    key: 'MX',
    value: 'Mexico',
    code: {
      a2: 'MX',
      a3: 'MEX',
    },
    shortList: 'x',
    houseNumber: false,
    state: true,
    parent: null,
    depType: null,
    stateTerm: 'stateProvince',
    currency: {
      code: 'MXN',
      name: 'Mexican Peso',
      symbol: '$',
    },
    num: 484,
    dialingCode: 52,
    langs: [
      {
        name: 'Spanish',
        code: 'es',
      },
    ],
    tz: [
      {
        name: 'Pacific Standard Time',
        code: 'PST',
        gmtOffset: -8,
      },
      {
        name: 'Eastern Standard Time',
        code: 'EST',
        gmtOffset: -5,
      },
    ],
    dst: true,
  },
  {
    key: 'MY',
    value: 'Malaysia',
    code: {
      a2: 'MY',
      a3: 'MYS',
    },
    shortList: 'x',
    houseNumber: false,
    state: true,
    parent: null,
    depType: null,
    stateTerm: 'stateProvince',
    currency: {
      code: 'MYR',
      name: 'Malaysian Ringgit',
      symbol: 'RM',
    },
    num: 458,
    dialingCode: 60,
    langs: [
      {
        name: 'Malay',
        code: 'ms',
      },
    ],
    tz: [
      {
        name: 'Malaysia Standard Time',
        code: 'MST',
        gmtOffset: '+8',
      },
      {
        name: 'Malaysia Standard Time',
        code: 'MST',
        gmtOffset: '+8',
      },
    ],
    dst: false,
  },
  {
    key: 'MZ',
    value: 'Mozambique',
    code: {
      a2: 'MZ',
      a3: 'MOZ',
    },
    shortList: 'x',
    houseNumber: false,
    state: false,
    parent: null,
    depType: null,
    stateTerm: null,
    currency: {
      code: 'MZN',
      name: 'Mozambican Metical',
      symbol: 'MT',
    },
    num: 508,
    dialingCode: 258,
    langs: [
      {
        name: 'Portuguese',
        code: 'pt',
      },
    ],
    tz: [
      {
        name: 'Central Africa Time',
        code: 'CAT',
        gmtOffset: '+2',
      },
      {
        name: 'Central Africa Time',
        code: 'CAT',
        gmtOffset: '+2',
      },
    ],
    dst: false,
  },
  {
    key: 'NA',
    value: 'Namibia',
    code: {
      a2: 'NA',
      a3: 'NAM',
    },
    shortList: 'x',
    houseNumber: false,
    state: false,
    parent: null,
    depType: null,
    stateTerm: null,
    currency: {
      code: 'NAD',
      name: 'Namibian Dollar',
      symbol: '$',
    },
    num: 516,
    dialingCode: 264,
    langs: [
      {
        name: 'English',
        code: 'en',
      },
    ],
    tz: [
      {
        name: 'Central Africa Time',
        code: 'CAT',
        gmtOffset: '+2',
      },
      {
        name: 'Central Africa Time',
        code: 'CAT',
        gmtOffset: '+2',
      },
    ],
    dst: false,
  },
  {
    key: 'NC',
    value: 'New Caledonia',
    code: {
      a2: 'NC',
      a3: 'NCL',
    },
    shortList: null,
    houseNumber: false,
    state: false,
    parent: 'FR',
    depType: 'dependent',
    stateTerm: null,
    currency: {
      code: 'XPF',
      name: 'CFP Franc',
      symbol: null,
    },
    num: 540,
    dialingCode: 687,
    langs: [
      {
        name: 'French',
        code: 'fr',
      },
    ],
    tz: [
      {
        name: 'New Caledonia Time',
        code: 'NCT',
        gmtOffset: '+11',
      },
      {
        name: 'New Caledonia Time',
        code: 'NCT',
        gmtOffset: '+11',
      },
    ],
    dst: false,
  },
  {
    key: 'NE',
    value: 'Niger',
    code: {
      a2: 'NE',
      a3: 'NER',
    },
    shortList: 'x',
    houseNumber: false,
    state: false,
    parent: null,
    depType: null,
    stateTerm: null,
    currency: {
      code: 'XOF',
      name: 'West African CFA franc',
      symbol: null,
    },
    num: 562,
    dialingCode: 227,
    langs: [
      {
        name: 'French',
        code: 'fr',
      },
    ],
    tz: [
      {
        name: 'West Africa Time',
        code: 'WAT',
        gmtOffset: '+1',
      },
      {
        name: 'West Africa Time',
        code: 'WAT',
        gmtOffset: '+1',
      },
    ],
    dst: false,
  },
  {
    key: 'NF',
    value: 'Norfolk Island',
    code: {
      a2: 'NF',
      a3: 'NFK',
    },
    shortList: null,
    houseNumber: false,
    state: false,
    parent: 'AU',
    depType: 'dependent',
    stateTerm: null,
    currency: {
      code: 'AUD',
      name: 'Australian Dollar',
      symbol: '$',
    },
    num: 574,
    dialingCode: 672,
    langs: [
      {
        name: 'English',
        code: 'en',
      },
      {
        name: 'Norfuk',
        code: null,
      },
    ],
    tz: [
      {
        name: 'Norfolk Time',
        code: 'NFT',
        gmtOffset: '+11.5',
      },
      {
        name: 'Norfolk Time',
        code: 'NFT',
        gmtOffset: '+11.5',
      },
    ],
    dst: false,
  },
  {
    key: 'NG',
    value: 'Nigeria',
    code: {
      a2: 'NG',
      a3: 'NGA',
    },
    shortList: 'x',
    houseNumber: false,
    state: true,
    parent: null,
    depType: null,
    stateTerm: 'stateProvince',
    currency: {
      code: 'NGN',
      name: 'Nigerian Naira',
      symbol: '₦',
    },
    num: 566,
    dialingCode: 234,
    langs: [
      {
        name: 'English',
        code: 'en',
      },
    ],
    tz: [
      {
        name: 'West Africa Time',
        code: 'WAT',
        gmtOffset: '+1',
      },
      {
        name: 'West Africa Time',
        code: 'WAT',
        gmtOffset: '+1',
      },
    ],
    dst: false,
  },
  {
    key: 'NI',
    value: 'Nicaragua',
    code: {
      a2: 'NI',
      a3: 'NIC',
    },
    shortList: 'x',
    houseNumber: false,
    state: false,
    parent: null,
    depType: null,
    stateTerm: null,
    currency: {
      code: 'NIO',
      name: 'Nicaraguan Córdoba',
      symbol: 'C$',
    },
    num: 558,
    dialingCode: 505,
    langs: [
      {
        name: 'Spanish',
        code: 'es',
      },
    ],
    tz: [
      {
        name: 'Central Standard Time',
        code: 'CST',
        gmtOffset: -6,
      },
      {
        name: 'Central Standard Time',
        code: 'CST',
        gmtOffset: -6,
      },
    ],
    dst: false,
  },
  {
    key: 'NL',
    value: 'Netherlands',
    code: {
      a2: 'NL',
      a3: 'NLD',
    },
    shortList: 'x',
    houseNumber: true,
    parent: null,
    depType: null,
    stateTerm: null,
    currency: {
      code: 'EUR',
      name: 'Euro',
      symbol: '€',
    },
    num: 528,
    dialingCode: 31,
    langs: [
      {
        name: 'Dutch',
        code: 'nl',
      },
    ],
    tz: [
      {
        name: 'Central European Time',
        code: 'CET',
        gmtOffset: '+1',
      },
      {
        name: 'Central European Time',
        code: 'CET',
        gmtOffset: '+1',
      },
    ],
    dst: true,
  },
  {
    key: 'NO',
    value: 'Norway',
    code: {
      a2: false,
      a3: 'NOR',
    },
    shortList: 'x',
    houseNumber: true,
    parent: null,
    depType: null,
    stateTerm: null,
    currency: {
      code: 'NOK',
      name: 'Norwegian Krone',
      symbol: 'kr',
    },
    num: 578,
    dialingCode: 47,
    langs: [
      {
        name: 'Norwegian',
        code: 'nb',
      },
    ],
    tz: [
      {
        name: 'Central European Time',
        code: 'CET',
        gmtOffset: '+1',
      },
      {
        name: 'Central European Time',
        code: 'CET',
        gmtOffset: '+1',
      },
    ],
    dst: true,
  },
  {
    key: 'NP',
    value: 'Nepal',
    code: {
      a2: 'NP',
      a3: 'NPL',
    },
    shortList: 'x',
    houseNumber: false,
    state: false,
    parent: null,
    depType: null,
    stateTerm: null,
    currency: {
      code: 'NPR',
      name: 'Nepalese Rupee',
      symbol: 'रू',
    },
    num: 524,
    dialingCode: 977,
    langs: [
      {
        name: 'Nepali',
        code: 'ne',
      },
    ],
    tz: [
      {
        name: 'Nepal Time',
        code: 'NPT',
        gmtOffset: '+5.75',
      },
      {
        name: 'Nepal Time',
        code: 'NPT',
        gmtOffset: '+5.75',
      },
    ],
    dst: false,
  },
  {
    key: 'NR',
    value: 'Nauru',
    code: {
      a2: 'NR',
      a3: 'NRU',
    },
    shortList: 'x',
    houseNumber: false,
    state: false,
    parent: null,
    depType: null,
    stateTerm: null,
    currency: {
      code: 'AUD',
      name: 'Australian Dollar',
      symbol: '$',
    },
    num: 520,
    dialingCode: 674,
    langs: [
      {
        name: 'Nauruan',
        code: null,
      },
      {
        name: 'English',
        code: 'en',
      },
    ],
    tz: [
      {
        name: 'Nauru Time',
        code: 'NRT',
        gmtOffset: '+12',
      },
      {
        name: 'Nauru Time',
        code: 'NRT',
        gmtOffset: '+12',
      },
    ],
    dst: false,
  },
  {
    key: 'NU',
    value: 'Niue',
    code: {
      a2: 'NU',
      a3: 'NIU',
    },
    shortList: null,
    houseNumber: false,
    state: false,
    parent: 'NZ',
    depType: 'associated',
    stateTerm: 'region',
    currency: {
      code: 'NZD',
      name: 'New Zealand Dollar',
      symbol: '$',
    },
    num: 570,
    dialingCode: 683,
    langs: [
      {
        name: 'Niuean',
        code: 'niu',
      },
      {
        name: 'English',
        code: 'en',
      },
    ],
    tz: [
      {
        name: 'Niue Standard Time',
        code: 'NST',
        gmtOffset: -11,
      },
      {
        name: 'Niue Standard Time',
        code: 'NST',
        gmtOffset: -11,
      },
    ],
    dst: false,
  },
  {
    key: 'NZ',
    value: 'New Zealand',
    code: {
      a2: 'NZ',
      a3: 'NZL',
    },
    shortList: 'x',
    houseNumber: false,
    state: true,
    parent: null,
    depType: null,
    stateTerm: null,
    currency: {
      code: 'NZD',
      name: 'New Zealand Dollar',
      symbol: '$',
    },
    num: 554,
    dialingCode: 64,
    langs: [
      {
        name: 'English',
        code: 'en',
      },
      {
        name: 'Maori',
        code: 'mi',
      },
    ],
    tz: [
      {
        name: 'New Zealand Standard Time',
        code: 'NZST',
        gmtOffset: '+12',
      },
      {
        name: 'Chatham Standard Time',
        code: 'CHAST',
        gmtOffset: '+12.75',
      },
    ],
    dst: true,
  },
  {
    key: 'OM',
    value: 'Oman',
    code: {
      a2: 'OM',
      a3: 'OMN',
    },
    shortList: 'x',
    houseNumber: false,
    state: false,
    parent: null,
    depType: null,
    stateTerm: null,
    currency: {
      code: 'OMR',
      name: 'Omani Rial',
      symbol: 'ر.ع',
    },
    num: 512,
    dialingCode: 968,
    langs: [
      {
        name: 'Arabic',
        code: 'ar',
      },
    ],
    tz: [
      {
        name: 'Gulf Standard Time',
        code: 'GST',
        gmtOffset: '+4',
      },
      {
        name: 'Gulf Standard Time',
        code: 'GST',
        gmtOffset: '+4',
      },
    ],
    dst: false,
  },
  {
    key: 'PA',
    value: 'Panama',
    code: {
      a2: 'PA',
      a3: 'PAN',
    },
    shortList: 'x',
    houseNumber: false,
    state: false,
    parent: null,
    depType: null,
    stateTerm: null,
    currency: {
      code: 'PAB',
      name: 'Panamanian Balboa',
      symbol: 'B/',
    },
    num: 591,
    dialingCode: 507,
    langs: [
      {
        name: 'Spanish',
        code: 'es',
      },
    ],
    tz: [
      {
        name: 'Eastern Standard Time',
        code: 'EST',
        gmtOffset: -5,
      },
      {
        name: 'Eastern Standard Time',
        code: 'EST',
        gmtOffset: -5,
      },
    ],
    dst: false,
  },
  {
    key: 'PE',
    value: 'Peru',
    code: {
      a2: 'PE',
      a3: 'PER',
    },
    shortList: 'x',
    houseNumber: false,
    state: false,
    parent: null,
    depType: null,
    stateTerm: null,
    currency: {
      code: 'PEN',
      name: 'Peruvian Sol',
      symbol: 'S/',
    },
    num: 604,
    dialingCode: 51,
    langs: [
      {
        name: 'Spanish',
        code: 'es',
      },
      {
        name: 'Quechua',
        code: 'qu',
      },
      {
        name: 'Aymara',
        code: 'ay',
      },
    ],
    tz: [
      {
        name: 'Peru Time',
        code: 'PET',
        gmtOffset: -5,
      },
      {
        name: 'Peru Time',
        code: 'PET',
        gmtOffset: -5,
      },
    ],
    dst: false,
  },
  {
    key: 'PF',
    value: 'French Polynesia',
    code: {
      a2: 'PF',
      a3: 'PYF',
    },
    shortList: null,
    houseNumber: false,
    state: false,
    parent: 'FR',
    depType: 'dependent',
    stateTerm: null,
    currency: {
      code: 'XPF',
      name: 'CFP Franc',
      symbol: null,
    },
    num: 258,
    dialingCode: 689,
    langs: [
      {
        name: 'French',
        code: 'fr',
      },
      {
        name: 'Tahitian',
        code: 'ty',
      },
    ],
    tz: [
      {
        name: 'Tahiti Time',
        code: 'TAHT',
        gmtOffset: -10,
      },
      {
        name: 'Gambier Time',
        code: 'GAMT',
        gmtOffset: -9,
      },
    ],
    dst: false,
  },
  {
    key: 'PG',
    value: 'Papua New Guinea',
    code: {
      a2: 'PG',
      a3: 'PNG',
    },
    shortList: 'x',
    houseNumber: false,
    state: false,
    parent: null,
    depType: null,
    stateTerm: null,
    currency: {
      code: 'PGK',
      name: 'Papua New Guinean Kina',
      symbol: 'K',
    },
    num: 598,
    dialingCode: 675,
    langs: [
      {
        name: 'Tok Pisin',
        code: 'tpi',
      },
      {
        name: 'English',
        code: 'en',
      },
      {
        name: 'Hiri Motu',
        code: 'ho',
      },
    ],
    tz: [
      {
        name: 'Papua New Guinea Time',
        code: 'PGT',
        gmtOffset: '+10',
      },
      {
        name: 'Papua New Guinea Time',
        code: 'PGT',
        gmtOffset: '+10',
      },
    ],
    dst: false,
  },
  {
    key: 'PH',
    value: 'Philippines',
    code: {
      a2: 'PH',
      a3: 'PHL',
    },
    shortList: 'x',
    houseNumber: false,
    state: false,
    parent: null,
    depType: null,
    stateTerm: null,
    currency: {
      code: 'PHP',
      name: 'Philippine Peso',
      symbol: '₱',
    },
    num: 608,
    dialingCode: 63,
    langs: [
      {
        name: 'Filipino',
        code: 'fil',
      },
      {
        name: 'English',
        code: 'en',
      },
    ],
    tz: [
      {
        name: 'Philippine Standard Time',
        code: 'PST',
        gmtOffset: '+8',
      },
      {
        name: 'Philippine Standard Time',
        code: 'PST',
        gmtOffset: '+8',
      },
    ],
    dst: false,
  },
  {
    key: 'PK',
    value: 'Pakistan',
    code: {
      a2: 'PK',
      a3: 'PAK',
    },
    shortList: 'x',
    houseNumber: false,
    state: true,
    parent: null,
    depType: null,
    stateTerm: 'stateProvince',
    currency: {
      code: 'PKR',
      name: 'Pakistani Rupee',
      symbol: '₨',
    },
    num: 586,
    dialingCode: 92,
    langs: [
      {
        name: 'Urdu',
        code: 'ur',
      },
      {
        name: 'English',
        code: 'en',
      },
    ],
    tz: [
      {
        name: 'Pakistan Standard Time',
        code: 'PKT',
        gmtOffset: '+5',
      },
      {
        name: 'Pakistan Standard Time',
        code: 'PKT',
        gmtOffset: '+5',
      },
    ],
    dst: false,
  },
  {
    key: 'PL',
    value: 'Poland',
    code: {
      a2: 'PL',
      a3: 'POL',
    },
    shortList: 'x',
    houseNumber: true,
    parent: null,
    depType: null,
    stateTerm: null,
    currency: {
      code: 'PLN',
      name: 'Polish Złoty',
      symbol: 'zł',
    },
    num: 616,
    dialingCode: 48,
    langs: [
      {
        name: 'Polish',
        code: 'pl',
      },
    ],
    tz: [
      {
        name: 'Central European Time',
        code: 'CET',
        gmtOffset: '+1',
      },
      {
        name: 'Central European Time',
        code: 'CET',
        gmtOffset: '+1',
      },
    ],
    dst: true,
  },
  {
    key: 'PM',
    value: 'Saint Pierre and Miquelon',
    code: {
      a2: 'PM',
      a3: 'SPM',
    },
    shortList: null,
    houseNumber: false,
    state: false,
    parent: 'FR',
    depType: 'dependent',
    stateTerm: null,
    currency: {
      code: 'EUR',
      name: 'Euro',
      symbol: '€',
    },
    num: 666,
    dialingCode: 508,
    langs: [
      {
        name: 'French',
        code: 'fr',
      },
    ],
    tz: [
      {
        name: 'Saint Pierre and Miquelon Standard Time',
        code: 'PMST',
        gmtOffset: -3,
      },
      {
        name: 'Saint Pierre and Miquelon Standard Time',
        code: 'PMST',
        gmtOffset: -3,
      },
    ],
    dst: true,
  },
  {
    key: 'PN',
    value: 'Pitcairn',
    code: {
      a2: 'PN',
      a3: 'PCN',
    },
    shortList: null,
    houseNumber: false,
    state: false,
    parent: 'GB',
    depType: 'dependent',
    stateTerm: null,
    currency: {
      code: 'NZD',
      name: 'New Zealand Dollar',
      symbol: '$',
    },
    num: 612,
    dialingCode: 870,
    langs: [
      {
        name: 'English',
        code: 'en',
      },
    ],
    tz: [
      {
        name: 'Pitcairn Standard Time',
        code: 'PST',
        gmtOffset: -8,
      },
      {
        name: 'Pitcairn Standard Time',
        code: 'PST',
        gmtOffset: -8,
      },
    ],
    dst: false,
  },
  {
    key: 'PR',
    value: 'Puerto Rico',
    code: {
      a2: 'PR',
      a3: 'PRI',
    },
    shortList: null,
    houseNumber: false,
    state: false,
    parent: 'US',
    depType: 'dependent',
    stateTerm: null,
    currency: {
      code: 'USD',
      name: 'US Dollar',
      symbol: '$',
    },
    num: 630,
    dialingCode: 1,
    langs: [
      {
        name: 'Spanish',
        code: 'es',
      },
      {
        name: 'English',
        code: 'en',
      },
    ],
    tz: [
      {
        name: 'Atlantic Standard Time',
        code: 'AST',
        gmtOffset: -4,
      },
      {
        name: 'Atlantic Standard Time',
        code: 'AST',
        gmtOffset: -4,
      },
    ],
    dst: false,
  },
  {
    key: 'PS',
    value: 'Palestine',
    code: {
      a2: 'PS',
      a3: 'PSE',
    },
    shortList: null,
    houseNumber: false,
    state: false,
    parent: null,
    depType: null,
    stateTerm: null,
    currency: {
      code: 'ILS',
      name: 'New Israeli Shekel',
      symbol: '₪',
    },
    num: 275,
    dialingCode: 970,
    langs: [
      {
        name: 'Arabic',
        code: 'ar',
      },
    ],
    tz: [
      {
        name: 'Eastern European Time',
        code: 'EET',
        gmtOffset: '+2',
      },
      {
        name: 'Eastern European Time',
        code: 'EET',
        gmtOffset: '+2',
      },
    ],
    dst: true,
  },
  {
    key: 'PT',
    value: 'Portugal',
    code: {
      a2: 'PT',
      a3: 'PRT',
    },
    shortList: 'x',
    houseNumber: false,
    state: false,
    parent: null,
    depType: null,
    stateTerm: null,
    currency: {
      code: 'EUR',
      name: 'Euro',
      symbol: '€',
    },
    num: 620,
    dialingCode: 351,
    langs: [
      {
        name: 'Portuguese',
        code: 'pt',
      },
    ],
    tz: [
      {
        name: 'Azores Standard Time',
        code: 'AZOT',
        gmtOffset: -1,
      },
      {
        name: 'Western European Time',
        code: 'WET',
        gmtOffset: '+0',
      },
    ],
    dst: true,
  },
  {
    key: 'PW',
    value: 'Palau',
    code: {
      a2: 'PW',
      a3: 'PLW',
    },
    shortList: 'x',
    houseNumber: false,
    state: false,
    parent: null,
    depType: null,
    stateTerm: null,
    currency: {
      code: 'USD',
      name: 'US Dollar',
      symbol: '$',
    },
    num: 585,
    dialingCode: 680,
    langs: [
      {
        name: 'Palauan',
        code: null,
      },
      {
        name: 'English',
        code: 'en',
      },
    ],
    tz: [
      {
        name: 'Palau Time',
        code: 'PWT',
        gmtOffset: '+9',
      },
      {
        name: 'Palau Time',
        code: 'PWT',
        gmtOffset: '+9',
      },
    ],
    dst: false,
  },
  {
    key: 'PY',
    value: 'Paraguay',
    code: {
      a2: 'PY',
      a3: 'PRY',
    },
    shortList: 'x',
    houseNumber: false,
    state: false,
    parent: null,
    depType: null,
    stateTerm: null,
    currency: {
      code: 'PYG',
      name: 'Paraguayan Guaraní',
      symbol: '₲',
    },
    num: 600,
    dialingCode: 595,
    langs: [
      {
        name: 'Spanish',
        code: 'es',
      },
      {
        name: 'Guarani',
        code: 'gn',
      },
    ],
    tz: [
      {
        name: 'Paraguay Summer Time',
        code: 'PYST',
        gmtOffset: -4,
      },
      {
        name: 'Paraguay Summer Time',
        code: 'PYST',
        gmtOffset: -4,
      },
    ],
    dst: true,
  },
  {
    key: 'QA',
    value: 'Qatar',
    code: {
      a2: 'QA',
      a3: 'QAT',
    },
    shortList: 'x',
    houseNumber: false,
    state: false,
    parent: null,
    depType: null,
    stateTerm: null,
    currency: {
      code: 'QAR',
      name: 'Qatari Riyal',
      symbol: '﷼',
    },
    num: 634,
    dialingCode: 974,
    langs: [
      {
        name: 'Arabic',
        code: 'ar',
      },
    ],
    tz: [
      {
        name: 'Arabia Standard Time',
        code: 'AST',
        gmtOffset: '+3',
      },
      {
        name: 'Arabia Standard Time',
        code: 'AST',
        gmtOffset: '+3',
      },
    ],
    dst: false,
  },
  {
    key: 'RE',
    value: 'Reunion',
    code: {
      a2: 'RE',
      a3: 'REU',
    },
    shortList: null,
    houseNumber: false,
    state: false,
    parent: 'FR',
    depType: 'dependent',
    stateTerm: null,
    currency: {
      code: 'EUR',
      name: 'Euro',
      symbol: '€',
    },
    num: 638,
    dialingCode: 262,
    langs: [
      {
        name: 'French',
        code: 'fr',
      },
      {
        name: 'Réunion Creole',
        code: null,
      },
    ],
    tz: [
      {
        name: 'Mauritius Time',
        code: 'MUT',
        gmtOffset: '+4',
      },
      {
        name: 'Mauritius Time',
        code: 'MUT',
        gmtOffset: '+4',
      },
    ],
    dst: false,
  },
  {
    key: 'RO',
    value: 'Romania',
    code: {
      a2: 'RO',
      a3: 'ROU',
    },
    shortList: 'x',
    houseNumber: false,
    state: false,
    parent: null,
    depType: null,
    stateTerm: null,
    currency: {
      code: 'RON',
      name: 'Romanian Leu',
      symbol: 'lei',
    },
    num: 642,
    dialingCode: 40,
    langs: [
      {
        name: 'Romanian',
        code: 'ro',
      },
    ],
    tz: [
      {
        name: 'Eastern European Time',
        code: 'EET',
        gmtOffset: '+2',
      },
      {
        name: 'Eastern European Time',
        code: 'EET',
        gmtOffset: '+2',
      },
    ],
    dst: true,
  },
  {
    key: 'RS',
    value: 'Serbia',
    code: {
      a2: 'RS',
      a3: 'SRB',
    },
    shortList: 'x',
    houseNumber: false,
    state: false,
    parent: null,
    depType: null,
    stateTerm: null,
    currency: {
      code: 'RSD',
      name: 'Serbian Dinar',
      symbol: 'дин',
    },
    num: 688,
    dialingCode: 381,
    langs: [
      {
        name: 'Serbian',
        code: 'sr',
      },
    ],
    tz: [
      {
        name: 'Central European Time',
        code: 'CET',
        gmtOffset: '+1',
      },
      {
        name: 'Central European Time',
        code: 'CET',
        gmtOffset: '+1',
      },
    ],
    dst: true,
  },
  {
    key: 'RU',
    value: 'Russia',
    code: {
      a2: 'RU',
      a3: 'RUS',
    },
    shortList: 'x',
    houseNumber: false,
    state: true,
    parent: null,
    depType: 'region',
    stateTerm: null,
    currency: {
      code: 'RUB',
      name: 'Russian Ruble',
      symbol: '₽',
    },
    num: 643,
    dialingCode: 7,
    langs: [
      {
        name: 'Russian',
        code: 'ru',
      },
    ],
    tz: [
      {
        name: 'Kaliningrad Time',
        code: 'KALT',
        gmtOffset: '+2',
      },
      {
        name: 'Kamchatka Time',
        code: 'PETT',
        gmtOffset: '+12',
      },
    ],
    dst: false,
  },
  {
    key: 'RW',
    value: 'Rwanda',
    code: {
      a2: 'RW',
      a3: 'RWA',
    },
    shortList: 'x',
    houseNumber: false,
    state: false,
    parent: null,
    depType: null,
    stateTerm: null,
    currency: {
      code: 'RWF',
      name: 'Rwandan Franc',
      symbol: 'FRw',
    },
    num: 646,
    dialingCode: 250,
    langs: [
      {
        name: 'Kinyarwanda',
        code: 'rw',
      },
      {
        name: 'English',
        code: 'en',
      },
      {
        name: 'French',
        code: 'fr',
      },
    ],
    tz: [
      {
        name: 'Central Africa Time',
        code: 'CAT',
        gmtOffset: '+2',
      },
      {
        name: 'Central Africa Time',
        code: 'CAT',
        gmtOffset: '+2',
      },
    ],
    dst: false,
  },
  {
    key: 'SA',
    value: 'Saudi Arabia',
    code: {
      a2: 'SA',
      a3: 'SAU',
    },
    shortList: 'x',
    houseNumber: false,
    state: false,
    parent: null,
    depType: null,
    stateTerm: null,
    currency: {
      code: 'SAR',
      name: 'Saudi Riyal',
      symbol: '﷼',
    },
    num: 682,
    dialingCode: 966,
    langs: [
      {
        name: 'Arabic',
        code: 'ar',
      },
    ],
    tz: [
      {
        name: 'Arabia Standard Time',
        code: 'AST',
        gmtOffset: '+3',
      },
      {
        name: 'Arabia Standard Time',
        code: 'AST',
        gmtOffset: '+3',
      },
    ],
    dst: false,
  },
  {
    key: 'SB',
    value: 'Solomon Islands',
    code: {
      a2: 'SB',
      a3: 'SLB',
    },
    shortList: 'x',
    houseNumber: false,
    state: false,
    parent: null,
    depType: null,
    stateTerm: null,
    currency: {
      code: 'SBD',
      name: 'Solomon Islands Dollar',
      symbol: '$',
    },
    num: 90,
    dialingCode: 677,
    langs: [
      {
        name: 'Solomon Islands Pijin',
        code: 'pis',
      },
      {
        name: 'English',
        code: 'en',
      },
    ],
    tz: [
      {
        name: 'Solomon Islands Time',
        code: 'SBT',
        gmtOffset: '+11',
      },
      {
        name: 'Solomon Islands Time',
        code: 'SBT',
        gmtOffset: '+11',
      },
    ],
    dst: false,
  },
  {
    key: 'SC',
    value: 'Seychelles',
    code: {
      a2: 'SC',
      a3: 'SYC',
    },
    shortList: 'x',
    houseNumber: false,
    state: false,
    parent: null,
    depType: null,
    stateTerm: null,
    currency: {
      code: 'SCR',
      name: 'Seychellois Rupee',
      symbol: '₨',
    },
    num: 690,
    dialingCode: 248,
    langs: [
      {
        name: 'Seychellois Creole',
        code: null,
      },
      {
        name: 'English',
        code: 'en',
      },
      {
        name: 'French',
        code: 'fr',
      },
    ],
    tz: [
      {
        name: 'Seychelles Time',
        code: 'SCT',
        gmtOffset: '+4',
      },
      {
        name: 'Seychelles Time',
        code: 'SCT',
        gmtOffset: '+4',
      },
    ],
    dst: false,
  },
  {
    key: 'SD',
    value: 'Sudan',
    code: {
      a2: 'SD',
      a3: 'SDN',
    },
    shortList: 'x',
    houseNumber: false,
    state: false,
    parent: null,
    depType: null,
    stateTerm: null,
    currency: {
      code: 'SDG',
      name: 'Sudanese Pound',
      symbol: 'ج.س',
    },
    num: 729,
    dialingCode: 249,
    langs: [
      {
        name: 'Arabic',
        code: 'ar',
      },
    ],
    tz: [
      {
        name: 'Central Africa Time',
        code: 'CAT',
        gmtOffset: '+2',
      },
      {
        name: 'Central Africa Time',
        code: 'CAT',
        gmtOffset: '+2',
      },
    ],
    dst: false,
  },
  {
    key: 'SE',
    value: 'Sweden',
    code: {
      a2: 'SE',
      a3: 'SWE',
    },
    shortList: 'x',
    houseNumber: true,
    parent: null,
    depType: null,
    stateTerm: null,
    currency: {
      code: 'SEK',
      name: 'Swedish Krona',
      symbol: 'kr',
    },
    num: 752,
    dialingCode: 46,
    langs: [
      {
        name: 'Swedish',
        code: 'sv',
      },
    ],
    tz: [
      {
        name: 'Central European Time',
        code: 'CET',
        gmtOffset: '+1',
      },
      {
        name: 'Central European Time',
        code: 'CET',
        gmtOffset: '+1',
      },
    ],
    dst: true,
  },
  {
    key: 'SG',
    value: 'Singapore',
    code: {
      a2: 'SG',
      a3: 'SGP',
    },
    shortList: 'x',
    houseNumber: false,
    state: false,
    parent: null,
    depType: null,
    stateTerm: null,
    currency: {
      code: 'SGD',
      name: 'Singapore Dollar',
      symbol: '$',
    },
    num: 702,
    dialingCode: 65,
    langs: [
      {
        name: 'English',
        code: 'en',
      },
    ],
    tz: [
      {
        name: 'Singapore Time',
        code: 'SGT',
        gmtOffset: '+8',
      },
      {
        name: 'Singapore Time',
        code: 'SGT',
        gmtOffset: '+8',
      },
    ],
    dst: false,
  },
  {
    key: 'SH',
    value: 'Saint Helena',
    code: {
      a2: 'SH',
      a3: 'SHN',
    },
    shortList: null,
    houseNumber: false,
    state: false,
    parent: 'GB',
    depType: 'dependent',
    stateTerm: null,
    currency: {
      code: 'SHP',
      name: 'Saint Helena Pound',
      symbol: '£',
    },
    num: 654,
    dialingCode: 290,
    langs: [
      {
        name: 'English',
        code: 'en',
      },
    ],
    tz: [
      {
        name: 'Greenwich Mean Time',
        code: 'GMT',
        gmtOffset: '+0',
      },
      {
        name: 'Greenwich Mean Time',
        code: 'GMT',
        gmtOffset: '+0',
      },
    ],
    dst: false,
  },
  {
    key: 'SI',
    value: 'Slovenia',
    code: {
      a2: 'SI',
      a3: 'SVN',
    },
    shortList: 'x',
    houseNumber: false,
    state: false,
    parent: null,
    depType: null,
    stateTerm: null,
    currency: {
      code: 'EUR',
      name: 'Euro',
      symbol: '€',
    },
    num: 705,
    dialingCode: 386,
    langs: [
      {
        name: 'Slovene',
        code: 'sl',
      },
    ],
    tz: [
      {
        name: 'Central European Time',
        code: 'CET',
        gmtOffset: '+1',
      },
      {
        name: 'Central European Time',
        code: 'CET',
        gmtOffset: '+1',
      },
    ],
    dst: true,
  },
  {
    key: 'SJ',
    value: 'Svalbard and Jan Mayen',
    code: {
      a2: 'SJ',
      a3: 'SJM',
    },
    shortList: null,
    houseNumber: false,
    state: false,
    parent: false,
    depType: 'dependent',
    stateTerm: null,
    currency: {
      code: 'NOK',
      name: 'Norwegian Krone',
      symbol: 'kr',
    },
    num: 744,
    dialingCode: 47,
    langs: [
      {
        name: 'Norwegian',
        code: null,
      },
    ],
    tz: [
      {
        name: 'Central European Time',
        code: 'CET',
        gmtOffset: '+1',
      },
      {
        name: 'Central European Time',
        code: 'CET',
        gmtOffset: '+1',
      },
    ],
    dst: true,
  },
  {
    key: 'SK',
    value: 'Slovakia',
    code: {
      a2: 'SK',
      a3: 'SVK',
    },
    shortList: 'x',
    houseNumber: false,
    state: false,
    parent: null,
    depType: null,
    stateTerm: null,
    currency: {
      code: 'EUR',
      name: 'Euro',
      symbol: '€',
    },
    num: 703,
    dialingCode: 421,
    langs: [
      {
        name: 'Slovak',
        code: 'sk',
      },
    ],
    tz: [
      {
        name: 'Central European Time',
        code: 'CET',
        gmtOffset: '+1',
      },
      {
        name: 'Central European Time',
        code: 'CET',
        gmtOffset: '+1',
      },
    ],
    dst: true,
  },
  {
    key: 'SL',
    value: 'Sierra Leone',
    code: {
      a2: 'SL',
      a3: 'SLE',
    },
    shortList: 'x',
    houseNumber: false,
    state: false,
    parent: null,
    depType: null,
    stateTerm: null,
    currency: {
      code: 'SLL',
      name: 'Sierra Leonean Leone',
      symbol: 'Le',
    },
    num: 694,
    dialingCode: 232,
    langs: [
      {
        name: 'English',
        code: 'en',
      },
    ],
    tz: [
      {
        name: 'Greenwich Mean Time',
        code: 'GMT',
        gmtOffset: '+0',
      },
      {
        name: 'Greenwich Mean Time',
        code: 'GMT',
        gmtOffset: '+0',
      },
    ],
    dst: false,
  },
  {
    key: 'SM',
    value: 'San Marino',
    code: {
      a2: 'SM',
      a3: 'SMR',
    },
    shortList: 'x',
    houseNumber: false,
    state: false,
    parent: null,
    depType: null,
    stateTerm: null,
    currency: {
      code: 'EUR',
      name: 'Euro',
      symbol: '€',
    },
    num: 674,
    dialingCode: 378,
    langs: [
      {
        name: 'Italian',
        code: 'it',
      },
    ],
    tz: [
      {
        name: 'Central European Time',
        code: 'CET',
        gmtOffset: '+1',
      },
      {
        name: 'Central European Time',
        code: 'CET',
        gmtOffset: '+1',
      },
    ],
    dst: true,
  },
  {
    key: 'SN',
    value: 'Senegal',
    code: {
      a2: 'SN',
      a3: 'SEN',
    },
    shortList: 'x',
    houseNumber: false,
    state: false,
    parent: null,
    depType: null,
    stateTerm: null,
    currency: {
      code: 'XOF',
      name: 'West African CFA franc',
      symbol: null,
    },
    num: 686,
    dialingCode: 221,
    langs: [
      {
        name: 'French',
        code: 'fr',
      },
      {
        name: 'Wolof',
        code: 'wo',
      },
    ],
    tz: [
      {
        name: 'Greenwich Mean Time',
        code: 'GMT',
        gmtOffset: '+0',
      },
      {
        name: 'Greenwich Mean Time',
        code: 'GMT',
        gmtOffset: '+0',
      },
    ],
    dst: false,
  },
  {
    key: 'SO',
    value: 'Somalia',
    code: {
      a2: 'SO',
      a3: 'SOM',
    },
    shortList: 'x',
    houseNumber: false,
    state: false,
    parent: null,
    depType: null,
    stateTerm: null,
    currency: {
      code: 'SOS',
      name: 'Somali Shilling',
      symbol: null,
    },
    num: 706,
    dialingCode: 252,
    langs: [
      {
        name: 'Somali',
        code: 'so',
      },
      {
        name: 'Arabic',
        code: 'ar',
      },
    ],
    tz: [
      {
        name: 'East Africa Time',
        code: 'EAT',
        gmtOffset: '+3',
      },
      {
        name: 'East Africa Time',
        code: 'EAT',
        gmtOffset: '+3',
      },
    ],
    dst: false,
  },
  {
    key: 'SR',
    value: 'Suriname',
    code: {
      a2: 'SR',
      a3: 'SUR',
    },
    shortList: 'x',
    houseNumber: false,
    state: false,
    parent: null,
    depType: null,
    stateTerm: null,
    currency: {
      code: 'SRD',
      name: 'Surinamese Dollar',
      symbol: '$',
    },
    num: 740,
    dialingCode: 597,
    langs: [
      {
        name: 'Dutch',
        code: 'nl',
      },
    ],
    tz: [
      {
        name: 'Suriname Time',
        code: 'SRT',
        gmtOffset: -3,
      },
      {
        name: 'Suriname Time',
        code: 'SRT',
        gmtOffset: -3,
      },
    ],
    dst: false,
  },
  {
    key: 'SS',
    value: 'South Sudan',
    code: {
      a2: 'SS',
      a3: 'SSD',
    },
    shortList: 'x',
    houseNumber: false,
    state: false,
    parent: null,
    depType: null,
    stateTerm: null,
    currency: {
      code: 'SSP',
      name: 'South Sudanese Pound',
      symbol: '£',
    },
    num: 728,
    dialingCode: 211,
    langs: [
      {
        name: 'English',
        code: 'en',
      },
    ],
    tz: [
      {
        name: 'Central Africa Time',
        code: 'CAT',
        gmtOffset: '+2',
      },
      {
        name: 'Central Africa Time',
        code: 'CAT',
        gmtOffset: '+2',
      },
    ],
    dst: false,
  },
  {
    key: 'ST',
    value: 'Sao Tome and Principe',
    code: {
      a2: 'ST',
      a3: 'STP',
    },
    shortList: null,
    houseNumber: false,
    state: false,
    parent: null,
    depType: null,
    stateTerm: null,
    currency: {
      code: 'STN',
      name: 'São Tomé and Príncipe Dobra',
      symbol: 'Db',
    },
    num: 678,
    dialingCode: 239,
    langs: [
      {
        name: 'Portuguese',
        code: 'pt',
      },
    ],
    tz: [
      {
        name: 'Greenwich Mean Time',
        code: 'GMT',
        gmtOffset: '+0',
      },
      {
        name: 'Greenwich Mean Time',
        code: 'GMT',
        gmtOffset: '+0',
      },
    ],
    dst: false,
  },
  {
    key: 'SV',
    value: 'El Salvador',
    code: {
      a2: 'SV',
      a3: 'SLV',
    },
    shortList: 'x',
    houseNumber: false,
    state: false,
    parent: null,
    depType: null,
    stateTerm: null,
    currency: {
      code: 'USD',
      name: 'US Dollar',
      symbol: '$',
    },
    num: 222,
    dialingCode: 503,
    langs: [
      {
        name: 'Spanish',
        code: 'es',
      },
    ],
    tz: [
      {
        name: 'Central Standard Time',
        code: 'CST',
        gmtOffset: -6,
      },
      {
        name: 'Central Standard Time',
        code: 'CST',
        gmtOffset: -6,
      },
    ],
    dst: false,
  },
  {
    key: 'SX',
    value: 'Sint Maarten (Dutch part)',
    code: {
      a2: 'SX',
      a3: 'SXM',
    },
    shortList: null,
    houseNumber: false,
    state: false,
    parent: 'NL',
    depType: 'dependent',
    stateTerm: null,
    currency: {
      code: 'ANG',
      name: 'Netherlands Antillean Guilder',
      symbol: 'ƒ',
    },
    num: 534,
    dialingCode: '1-721',
    langs: [
      {
        name: 'English',
        code: 'en',
      },
      {
        name: 'Dutch',
        code: 'nl',
      },
    ],
    tz: [
      {
        name: 'Atlantic Standard Time',
        code: 'AST',
        gmtOffset: -4,
      },
      {
        name: 'Atlantic Standard Time',
        code: 'AST',
        gmtOffset: -4,
      },
    ],
    dst: false,
  },
  {
    key: 'SY',
    value: 'Syrian Arab Republic',
    code: {
      a2: 'SY',
      a3: 'SYR',
    },
    shortList: 'x',
    houseNumber: false,
    state: false,
    parent: null,
    depType: null,
    stateTerm: null,
    currency: {
      code: 'SYP',
      name: 'Syrian Pound',
      symbol: null,
    },
    num: 760,
    dialingCode: 963,
    langs: [
      {
        name: 'Arabic',
        code: 'ar',
      },
    ],
    tz: [
      {
        name: 'Eastern European Time',
        code: 'EET',
        gmtOffset: '+2',
      },
      {
        name: 'Eastern European Time',
        code: 'EET',
        gmtOffset: '+2',
      },
    ],
    dst: true,
  },
  {
    key: 'SZ',
    value: 'Swaziland',
    code: {
      a2: 'SZ',
      a3: 'SWZ',
    },
    shortList: 'x',
    houseNumber: false,
    state: false,
    parent: null,
    depType: null,
    stateTerm: null,
    currency: {
      code: 'SZL',
      name: 'Swazi Lilangeni',
      symbol: 'E',
    },
    num: 748,
    dialingCode: 268,
    langs: [
      {
        name: 'Swazi',
        code: 'ss',
      },
      {
        name: 'English',
        code: 'en',
      },
    ],
    tz: [
      {
        name: 'South Africa Standard Time',
        code: 'SAST',
        gmtOffset: '+2',
      },
      {
        name: 'South Africa Standard Time',
        code: 'SAST',
        gmtOffset: '+2',
      },
    ],
    dst: false,
  },
  {
    key: 'TC',
    value: 'Turks and Caicos Islands',
    code: {
      a2: 'TC',
      a3: 'TCA',
    },
    shortList: null,
    houseNumber: false,
    state: false,
    parent: 'BG',
    depType: 'dependent',
    stateTerm: null,
    currency: {
      code: 'USD',
      name: 'US Dollar',
      symbol: '$',
    },
    num: 796,
    dialingCode: '1-649',
    langs: [
      {
        name: 'English',
        code: 'en',
      },
    ],
    tz: [
      {
        name: 'Eastern Standard Time',
        code: 'EST',
        gmtOffset: -5,
      },
      {
        name: 'Eastern Standard Time',
        code: 'EST',
        gmtOffset: -5,
      },
    ],
    dst: false,
  },
  {
    key: 'TD',
    value: 'Chad',
    code: {
      a2: 'TD',
      a3: 'TCD',
    },
    shortList: 'x',
    houseNumber: false,
    state: false,
    parent: null,
    depType: null,
    stateTerm: null,
    currency: {
      code: 'XAF',
      name: 'Central African CFA franc',
      symbol: null,
    },
    num: 148,
    dialingCode: 235,
    langs: [
      {
        name: 'French',
        code: 'fr',
      },
      {
        name: 'Arabic',
        code: 'ar',
      },
    ],
    tz: [
      {
        name: 'West Africa Time',
        code: 'WAT',
        gmtOffset: '+1',
      },
      {
        name: 'West Africa Time',
        code: 'WAT',
        gmtOffset: '+1',
      },
    ],
    dst: false,
  },
  {
    key: 'TF',
    value: 'French Southern Territories',
    code: {
      a2: 'TF',
      a3: 'ATF',
    },
    shortList: null,
    houseNumber: false,
    state: false,
    parent: 'FR',
    depType: 'dependent',
    stateTerm: null,
    currency: {
      code: 'EUR',
      name: 'Euro',
      symbol: '€',
    },
    num: 260,
    dialingCode: 262,
    langs: [
      {
        name: 'French',
        code: 'fr',
      },
    ],
    tz: [],
    dst: null,
  },
  {
    key: 'TG',
    value: 'Togo',
    code: {
      a2: 'TG',
      a3: 'TGO',
    },
    shortList: 'x',
    houseNumber: false,
    state: false,
    parent: null,
    depType: null,
    stateTerm: null,
    currency: {
      code: 'XOF',
      name: 'West African CFA franc',
      symbol: null,
    },
    num: 768,
    dialingCode: 228,
    langs: [
      {
        name: 'French',
        code: 'fr',
      },
    ],
    tz: [
      {
        name: 'Greenwich Mean Time',
        code: 'GMT',
        gmtOffset: '+0',
      },
      {
        name: 'Greenwich Mean Time',
        code: 'GMT',
        gmtOffset: '+0',
      },
    ],
    dst: false,
  },
  {
    key: 'TH',
    value: 'Thailand',
    code: {
      a2: 'TH',
      a3: 'THA',
    },
    shortList: 'x',
    houseNumber: false,
    state: false,
    parent: null,
    depType: null,
    stateTerm: null,
    currency: {
      code: 'THB',
      name: 'Thai Baht',
      symbol: '฿',
    },
    num: 764,
    dialingCode: 66,
    langs: [
      {
        name: 'Thai',
        code: 'th',
      },
    ],
    tz: [
      {
        name: 'Indochina Time',
        code: 'ICT',
        gmtOffset: '+7',
      },
      {
        name: 'Indochina Time',
        code: 'ICT',
        gmtOffset: '+7',
      },
    ],
    dst: false,
  },
  {
    key: 'TJ',
    value: 'Tajikistan',
    code: {
      a2: 'TJ',
      a3: 'TJK',
    },
    shortList: 'x',
    houseNumber: false,
    state: false,
    parent: null,
    depType: null,
    stateTerm: null,
    currency: {
      code: 'TJS',
      name: 'Tajikistani Somoni',
      symbol: null,
    },
    num: 762,
    dialingCode: 992,
    langs: [
      {
        name: 'Tajik',
        code: 'tg',
      },
    ],
    tz: [
      {
        name: 'Tajikistan Time',
        code: 'TJT',
        gmtOffset: '+5',
      },
      {
        name: 'Tajikistan Time',
        code: 'TJT',
        gmtOffset: '+5',
      },
    ],
    dst: false,
  },
  {
    key: 'TK',
    value: 'Tokelau',
    code: {
      a2: 'TK',
      a3: 'TKL',
    },
    shortList: null,
    houseNumber: false,
    state: false,
    parent: 'NZ',
    depType: 'dependent',
    stateTerm: null,
    currency: {
      code: 'NZD',
      name: 'New Zealand Dollar',
      symbol: '$',
    },
    num: 772,
    dialingCode: 690,
    langs: [
      {
        name: 'Tokelauan',
        code: null,
      },
      {
        name: 'English',
        code: 'en',
      },
    ],
    tz: [
      {
        name: 'Tokelau Time',
        code: 'TKT',
        gmtOffset: '+13',
      },
      {
        name: 'Tokelau Time',
        code: 'TKT',
        gmtOffset: '+13',
      },
    ],
    dst: false,
  },
  {
    key: 'TL',
    value: 'Timor-Leste',
    code: {
      a2: 'TL',
      a3: 'TLS',
    },
    shortList: 'x',
    houseNumber: false,
    state: false,
    parent: null,
    depType: null,
    stateTerm: null,
    currency: {
      code: 'USD',
      name: 'US Dollar',
      symbol: '$',
    },
    num: 626,
    dialingCode: 670,
    langs: [
      {
        name: 'Tetum',
        code: null,
      },
      {
        name: 'Portuguese',
        code: 'pt',
      },
    ],
    tz: [
      {
        name: 'Timor Leste Time',
        code: 'TLT',
        gmtOffset: '+9',
      },
      {
        name: 'Timor Leste Time',
        code: 'TLT',
        gmtOffset: '+9',
      },
    ],
    dst: false,
  },
  {
    key: 'TM',
    value: 'Turkmenistan',
    code: {
      a2: 'TM',
      a3: 'TKM',
    },
    shortList: 'x',
    houseNumber: false,
    state: false,
    parent: null,
    depType: null,
    stateTerm: null,
    currency: {
      code: 'TMT',
      name: 'Turkmenistani Manat',
      symbol: 'm',
    },
    num: 795,
    dialingCode: 993,
    langs: [
      {
        name: 'Turkmen',
        code: 'tk',
      },
    ],
    tz: [
      {
        name: 'Turkmenistan Time',
        code: 'TMT',
        gmtOffset: '+5',
      },
      {
        name: 'Turkmenistan Time',
        code: 'TMT',
        gmtOffset: '+5',
      },
    ],
    dst: false,
  },
  {
    key: 'TN',
    value: 'Tunisia',
    code: {
      a2: 'TN',
      a3: 'TUN',
    },
    shortList: 'x',
    houseNumber: false,
    state: false,
    parent: null,
    depType: null,
    stateTerm: null,
    currency: {
      code: 'TND',
      name: 'Tunisian Dinar',
      symbol: 'د.ت',
    },
    num: 788,
    dialingCode: 216,
    langs: [
      {
        name: 'Arabic',
        code: 'ar',
      },
    ],
    tz: [
      {
        name: 'Central European Time',
        code: 'CET',
        gmtOffset: '+1',
      },
      {
        name: 'Central European Time',
        code: 'CET',
        gmtOffset: '+1',
      },
    ],
    dst: false,
  },
  {
    key: 'TO',
    value: 'Tonga',
    code: {
      a2: 'TO',
      a3: 'TON',
    },
    shortList: 'x',
    houseNumber: false,
    state: false,
    parent: null,
    depType: null,
    stateTerm: null,
    currency: {
      code: 'TOP',
      name: 'Tongan Paʻanga',
      symbol: 'T$',
    },
    num: 776,
    dialingCode: 676,
    langs: [
      {
        name: 'Tongan',
        code: 'to',
      },
      {
        name: 'English',
        code: 'en',
      },
    ],
    tz: [
      {
        name: 'Tonga Time',
        code: 'TOT',
        gmtOffset: '+13',
      },
      {
        name: 'Tonga Time',
        code: 'TOT',
        gmtOffset: '+13',
      },
    ],
    dst: true,
  },
  {
    key: 'TR',
    value: 'Turkey',
    code: {
      a2: 'TR',
      a3: 'TUR',
    },
    shortList: 'x',
    houseNumber: false,
    state: false,
    parent: null,
    depType: null,
    stateTerm: null,
    currency: {
      code: 'TRY',
      name: 'Turkish Lira',
      symbol: '₺',
    },
    num: 792,
    dialingCode: 90,
    langs: [
      {
        name: 'Turkish',
        code: 'tr',
      },
    ],
    tz: [
      {
        name: 'Turkey Time',
        code: 'TRT',
        gmtOffset: '+3',
      },
      {
        name: 'Turkey Time',
        code: 'TRT',
        gmtOffset: '+3',
      },
    ],
    dst: false,
  },
  {
    key: 'TT',
    value: 'Trinidad and Tobago',
    code: {
      a2: 'TT',
      a3: 'TTO',
    },
    shortList: 'x',
    houseNumber: false,
    state: false,
    parent: null,
    depType: null,
    stateTerm: null,
    currency: {
      code: 'TTD',
      name: 'Trinidad and Tobago Dollar',
      symbol: 'TT$',
    },
    num: 780,
    dialingCode: '1-868',
    langs: [
      {
        name: 'English',
        code: 'en',
      },
    ],
    tz: [
      {
        name: 'Atlantic Standard Time',
        code: 'AST',
        gmtOffset: -4,
      },
      {
        name: 'Atlantic Standard Time',
        code: 'AST',
        gmtOffset: -4,
      },
    ],
    dst: false,
  },
  {
    key: 'TV',
    value: 'Tuvalu',
    code: {
      a2: 'TV',
      a3: 'TUV',
    },
    shortList: 'x',
    houseNumber: false,
    state: false,
    parent: null,
    depType: null,
    stateTerm: null,
    currency: {
      code: 'AUD',
      name: 'Australian Dollar',
      symbol: '$',
    },
    num: 798,
    dialingCode: 688,
    langs: [
      {
        name: 'Tuvaluan',
        code: 'tvl',
      },
      {
        name: 'English',
        code: 'en',
      },
    ],
    tz: [
      {
        name: 'Tuvalu Time',
        code: 'TVT',
        gmtOffset: '+12',
      },
      {
        name: 'Tuvalu Time',
        code: 'TVT',
        gmtOffset: '+12',
      },
    ],
    dst: false,
  },
  {
    key: 'TW',
    value: 'Taiwan',
    code: {
      a2: 'TW',
      a3: 'TWN',
    },
    shortList: 'x',
    houseNumber: false,
    state: false,
    parent: null,
    depType: null,
    stateTerm: null,
    currency: {
      code: 'TWD',
      name: 'New Taiwan Dollar',
      symbol: 'NT$',
    },
    num: 158,
    dialingCode: 886,
    langs: [
      {
        name: 'Mandarin Chinese',
        code: 'zh',
      },
    ],
    tz: [
      {
        name: 'China Standard Time',
        code: 'CST',
        gmtOffset: '+8',
      },
      {
        name: 'China Standard Time',
        code: 'CST',
        gmtOffset: '+8',
      },
    ],
    dst: false,
  },
  {
    key: 'TZ',
    value: 'United Republic of Tanzania',
    code: {
      a2: 'TZ',
      a3: 'TZA',
    },
    shortList: 'x',
    houseNumber: false,
    state: false,
    parent: null,
    depType: null,
    stateTerm: null,
    currency: {
      code: 'TZS',
      name: 'Tanzanian Shilling',
      symbol: 'TSh',
    },
    num: 834,
    dialingCode: 255,
    langs: [
      {
        name: 'Swahili',
        code: 'sw',
      },
      {
        name: 'English',
        code: 'en',
      },
    ],
    tz: [
      {
        name: 'East Africa Time',
        code: 'EAT',
        gmtOffset: '+3',
      },
      {
        name: 'East Africa Time',
        code: 'EAT',
        gmtOffset: '+3',
      },
    ],
    dst: false,
  },
  {
    key: 'UA',
    value: 'Ukraine',
    code: {
      a2: 'UA',
      a3: 'UKR',
    },
    shortList: 'x',
    houseNumber: false,
    state: false,
    parent: null,
    depType: null,
    stateTerm: null,
    currency: {
      code: 'UAH',
      name: 'Ukrainian Hryvnia',
      symbol: '₴',
    },
    num: 804,
    dialingCode: 380,
    langs: [
      {
        name: 'Ukrainian',
        code: 'uk',
      },
    ],
    tz: [
      {
        name: 'Eastern European Time',
        code: 'EET',
        gmtOffset: '+2',
      },
      {
        name: 'Eastern European Time',
        code: 'EET',
        gmtOffset: '+2',
      },
    ],
    dst: true,
  },
  {
    key: 'UG',
    value: 'Uganda',
    code: {
      a2: 'UG',
      a3: 'UGA',
    },
    shortList: 'x',
    houseNumber: false,
    state: false,
    parent: null,
    depType: null,
    stateTerm: null,
    currency: {
      code: 'UGX',
      name: 'Ugandan Shilling',
      symbol: 'USh',
    },
    num: 800,
    dialingCode: 256,
    langs: [
      {
        name: 'English',
        code: 'en',
      },
      {
        name: 'Swahili',
        code: 'sw',
      },
    ],
    tz: [
      {
        name: 'East Africa Time',
        code: 'EAT',
        gmtOffset: '+3',
      },
      {
        name: 'East Africa Time',
        code: 'EAT',
        gmtOffset: '+3',
      },
    ],
    dst: false,
  },
  {
    key: 'UM',
    value: 'United States Minor Outlying Islands',
    code: {
      a2: 'UM',
      a3: 'UMI',
    },
    shortList: null,
    houseNumber: false,
    state: false,
    parent: 'US',
    depType: 'dependent',
    stateTerm: null,
    currency: {
      code: 'USD',
      name: 'US Dollar',
      symbol: '$',
    },
    num: 581,
    dialingCode: 1,
    langs: [
      {
        name: 'English',
        code: 'en',
      },
    ],
    tz: [],
    dst: false,
  },
  {
    key: 'US',
    value: 'United States',
    code: {
      a2: 'US',
      a3: 'USA',
    },
    shortList: 'x',
    houseNumber: false,
    state: true,
    parent: null,
    depType: null,
    stateTerm: 'stateProvince',
    currency: {
      code: 'USD',
      name: 'US Dollar',
      symbol: '$',
    },
    num: 840,
    dialingCode: 1,
    langs: [
      {
        name: 'English',
        code: 'en',
      },
    ],
    tz: [
      {
        name: 'Hawaii Standard Time',
        code: 'HST',
        gmtOffset: -10,
      },
      {
        name: 'Eastern Standard Time',
        code: 'EST',
        gmtOffset: -5,
      },
    ],
    dst: true,
  },
  {
    key: 'UY',
    value: 'Uruguay',
    code: {
      a2: 'UY',
      a3: 'URY',
    },
    shortList: 'x',
    houseNumber: false,
    state: false,
    parent: null,
    depType: null,
    stateTerm: null,
    currency: {
      code: 'UYU',
      name: 'Uruguayan Peso',
      symbol: '$U',
    },
    num: 858,
    dialingCode: 598,
    langs: [
      {
        name: 'Spanish',
        code: 'es',
      },
    ],
    tz: [
      {
        name: 'Uruguay Time',
        code: 'UYT',
        gmtOffset: -3,
      },
      {
        name: 'Uruguay Time',
        code: 'UYT',
        gmtOffset: -3,
      },
    ],
    dst: false,
  },
  {
    key: 'UZ',
    value: 'Uzbekistan',
    code: {
      a2: 'UZ',
      a3: 'UZB',
    },
    shortList: 'x',
    houseNumber: false,
    state: false,
    parent: null,
    depType: null,
    stateTerm: null,
    currency: {
      code: 'UZS',
      name: 'Uzbekistani Som',
      symbol: null,
    },
    num: 860,
    dialingCode: 998,
    langs: [
      {
        name: 'Uzbek',
        code: 'uz',
      },
    ],
    tz: [
      {
        name: 'Uzbekistan Time',
        code: 'UZT',
        gmtOffset: '+5',
      },
      {
        name: 'Uzbekistan Time',
        code: 'UZT',
        gmtOffset: '+5',
      },
    ],
    dst: false,
  },
  {
    key: 'VA',
    value: 'Holy See (Vatican City State)',
    code: {
      a2: 'VA',
      a3: 'VAT',
    },
    shortList: 'x',
    houseNumber: false,
    state: false,
    parent: null,
    depType: null,
    stateTerm: null,
    currency: {
      code: 'EUR',
      name: 'Euro',
      symbol: '€',
    },
    num: 336,
    dialingCode: 379,
    langs: [
      {
        name: 'Latin',
        code: 'la',
      },
      {
        name: 'Italian',
        code: 'it',
      },
    ],
    tz: [
      {
        name: 'Central European Time',
        code: 'CET',
        gmtOffset: '+1',
      },
      {
        name: 'Central European Time',
        code: 'CET',
        gmtOffset: '+1',
      },
    ],
    dst: true,
  },
  {
    key: 'VC',
    value: 'Saint Vincent and the Grenadines',
    code: {
      a2: 'VC',
      a3: 'VCT',
    },
    shortList: 'x',
    houseNumber: false,
    state: false,
    parent: null,
    depType: null,
    stateTerm: null,
    currency: {
      code: 'XCD',
      name: 'East Caribbean Dollar',
      symbol: null,
    },
    num: 670,
    dialingCode: '1-784',
    langs: [
      {
        name: 'English',
        code: 'en',
      },
    ],
    tz: [
      {
        name: 'Atlantic Standard Time',
        code: 'AST',
        gmtOffset: -4,
      },
      {
        name: 'Atlantic Standard Time',
        code: 'AST',
        gmtOffset: -4,
      },
    ],
    dst: false,
  },
  {
    key: 'VE',
    value: 'Venezuela',
    code: {
      a2: 'VE',
      a3: 'VEN',
    },
    shortList: 'x',
    houseNumber: false,
    state: true,
    parent: null,
    depType: null,
    stateTerm: 'stateProvince',
    currency: {
      code: 'VES',
      name: 'Venezuelan Bolívar',
      symbol: 'Bs.S',
    },
    num: 862,
    dialingCode: 58,
    langs: [
      {
        name: 'Spanish',
        code: 'es',
      },
    ],
    tz: [
      {
        name: 'Venezuela Time',
        code: 'VET',
        gmtOffset: -4,
      },
      {
        name: 'Venezuela Time',
        code: 'VET',
        gmtOffset: -4,
      },
    ],
    dst: false,
  },
  {
    key: 'VG',
    value: 'British Virgin Islands',
    code: {
      a2: 'VG',
      a3: 'VGB',
    },
    shortList: null,
    houseNumber: false,
    state: false,
    parent: 'GB',
    depType: 'dependent',
    stateTerm: null,
    currency: {
      code: 'USD',
      name: 'US Dollar',
      symbol: '$',
    },
    num: 92,
    dialingCode: '1-284',
    langs: [
      {
        name: 'English',
        code: 'en',
      },
    ],
    tz: [
      {
        name: 'Atlantic Standard Time',
        code: 'AST',
        gmtOffset: -4,
      },
      {
        name: 'Atlantic Standard Time',
        code: 'AST',
        gmtOffset: -4,
      },
    ],
    dst: false,
  },
  {
    key: 'VI',
    value: 'US Virgin Islands',
    code: {
      a2: 'VI',
      a3: 'VIR',
    },
    shortList: null,
    houseNumber: false,
    state: false,
    parent: 'US',
    depType: 'dependent',
    stateTerm: null,
    currency: {
      code: 'USD',
      name: 'US Dollar',
      symbol: '$',
    },
    num: 850,
    dialingCode: '1-340',
    langs: [
      {
        name: 'English',
        code: 'en',
      },
    ],
    tz: [
      {
        name: 'Atlantic Standard Time',
        code: 'AST',
        gmtOffset: -4,
      },
      {
        name: 'Atlantic Standard Time',
        code: 'AST',
        gmtOffset: -4,
      },
    ],
    dst: false,
  },
  {
    key: 'VN',
    value: 'Viet Nam',
    code: {
      a2: 'VN',
      a3: 'VNM',
    },
    shortList: 'x',
    houseNumber: false,
    state: false,
    parent: null,
    depType: null,
    stateTerm: null,
    currency: {
      code: 'VND',
      name: 'Vietnamese đồng',
      symbol: '₫',
    },
    num: 704,
    dialingCode: 84,
    langs: [
      {
        name: 'Vietnamese',
        code: 'vi',
      },
    ],
    tz: [
      {
        name: 'Indochina Time',
        code: 'ICT',
        gmtOffset: '+7',
      },
      {
        name: 'Indochina Time',
        code: 'ICT',
        gmtOffset: '+7',
      },
    ],
    dst: false,
  },
  {
    key: 'VU',
    value: 'Vanuatu',
    code: {
      a2: 'VU',
      a3: 'VUT',
    },
    shortList: 'x',
    houseNumber: false,
    state: false,
    parent: null,
    depType: null,
    stateTerm: null,
    currency: {
      code: 'VUV',
      name: 'Vatu',
      symbol: 'Vt',
    },
    num: 548,
    dialingCode: 678,
    langs: [
      {
        name: 'Bislama',
        code: 'bi',
      },
      {
        name: 'English',
        code: 'en',
      },
      {
        name: 'French',
        code: 'fr',
      },
    ],
    tz: [
      {
        name: 'Vanuatu Time',
        code: 'VUT',
        gmtOffset: '+11',
      },
      {
        name: 'Vanuatu Time',
        code: 'VUT',
        gmtOffset: '+11',
      },
    ],
    dst: false,
  },
  {
    key: 'WF',
    value: 'Wallis and Futuna',
    code: {
      a2: 'WF',
      a3: 'WLF',
    },
    shortList: null,
    houseNumber: false,
    state: false,
    parent: 'FR',
    depType: 'dependent',
    stateTerm: null,
    currency: {
      code: 'XPF',
      name: 'CFP Franc',
      symbol: null,
    },
    num: 876,
    dialingCode: 681,
    langs: [
      {
        name: 'French',
        code: 'fr',
      },
      {
        name: 'Wallisian',
        code: null,
      },
    ],
    tz: [
      {
        name: 'Wallis and Futuna Time',
        code: 'WFT',
        gmtOffset: '+12',
      },
      {
        name: 'Wallis and Futuna Time',
        code: 'WFT',
        gmtOffset: '+12',
      },
    ],
    dst: false,
  },
  {
    key: 'WS',
    value: 'Samoa',
    code: {
      a2: 'WS',
      a3: 'WSM',
    },
    shortList: 'x',
    houseNumber: false,
    state: false,
    parent: null,
    depType: null,
    stateTerm: null,
    currency: {
      code: 'WST',
      name: 'Samoan Tala',
      symbol: 'T',
    },
    num: 882,
    dialingCode: 685,
    langs: [
      {
        name: 'Samoan',
        code: 'sm',
      },
      {
        name: 'English',
        code: 'en',
      },
    ],
    tz: [
      {
        name: 'Samoa Standard Time',
        code: 'SST',
        gmtOffset: '+13',
      },
      {
        name: 'Samoa Standard Time',
        code: 'SST',
        gmtOffset: '+13',
      },
    ],
    dst: false,
  },
  {
    key: 'XK',
    value: 'Kosovo',
    code: {
      a2: 'XK',
      a3: 'XKX',
    },
    shortList: 'x',
    houseNumber: false,
    state: false,
    parent: null,
    depType: null,
    stateTerm: null,
    currency: {
      code: 'EUR',
      name: 'Euro',
      symbol: '€',
    },
    num: 887,
    dialingCode: 383,
    langs: [
      {
        name: 'Albanian',
        code: 'sq',
      },
    ],
    tz: [
      {
        name: 'Central European Time',
        code: 'CET',
        gmtOffset: '+1',
      },
      {
        name: 'Central European Time',
        code: 'CET',
        gmtOffset: '+1',
      },
    ],
    dst: false,
  },
  {
    key: 'YE',
    value: 'Yemen',
    code: {
      a2: 'YE',
      a3: 'YEM',
    },
    shortList: 'x',
    houseNumber: false,
    state: false,
    parent: null,
    depType: null,
    stateTerm: null,
    currency: {
      code: 'YER',
      name: 'Yemeni Rial',
      symbol: '﷼',
    },
    num: 887,
    dialingCode: 967,
    langs: [
      {
        name: 'Arabic',
        code: 'ar',
      },
    ],
    tz: [
      {
        name: 'Arabia Standard Time',
        code: 'AST',
        gmtOffset: '+3',
      },
      {
        name: 'Arabia Standard Time',
        code: 'AST',
        gmtOffset: '+3',
      },
    ],
    dst: false,
  },
  {
    key: 'YT',
    value: 'Mayotte',
    code: {
      a2: 'YT',
      a3: 'MYT',
    },
    shortList: null,
    houseNumber: false,
    state: false,
    parent: 'FR',
    depType: 'dependent',
    stateTerm: null,
    currency: {
      code: 'EUR',
      name: 'Euro',
      symbol: '€',
    },
    num: 175,
    dialingCode: 262,
    langs: [
      {
        name: 'French',
        code: 'fr',
      },
    ],
    tz: [
      {
        name: 'East Africa Time',
        code: 'EAT',
        gmtOffset: '+3',
      },
      {
        name: 'East Africa Time',
        code: 'EAT',
        gmtOffset: '+3',
      },
    ],
    dst: false,
  },
  {
    key: 'ZA',
    value: 'South Africa',
    code: {
      a2: 'ZA',
      a3: 'ZAF',
    },
    shortList: 'x',
    houseNumber: false,
    state: true,
    parent: null,
    depType: null,
    stateTerm: 'province',
    currency: {
      code: 'ZAR',
      name: 'South African Rand',
      symbol: 'R',
    },
    num: 710,
    dialingCode: 27,
    langs: [
      {
        name: 'English',
        code: 'en',
      },
      {
        name: 'Afrikaans',
        code: 'af',
      },
      {
        name: 'Zulu',
        code: 'zu',
      },
    ],
    tz: [
      {
        name: 'South Africa Standard Time',
        code: 'SAST',
        gmtOffset: '+2',
      },
      {
        name: 'South Africa Standard Time',
        code: 'SAST',
        gmtOffset: '+2',
      },
    ],
    dst: false,
  },
  {
    key: 'ZM',
    value: 'Zambia',
    code: {
      a2: 'ZM',
      a3: 'ZMB',
    },
    shortList: 'x',
    houseNumber: false,
    state: false,
    parent: null,
    depType: null,
    stateTerm: null,
    currency: {
      code: 'ZMW',
      name: 'Zambian Kwacha',
      symbol: 'ZK',
    },
    num: 894,
    dialingCode: 260,
    langs: [
      {
        name: 'English',
        code: 'en',
      },
    ],
    tz: [
      {
        name: 'Central Africa Time',
        code: 'CAT',
        gmtOffset: '+2',
      },
      {
        name: 'Central Africa Time',
        code: 'CAT',
        gmtOffset: '+2',
      },
    ],
    dst: false,
  },
  {
    key: 'ZW',
    value: 'Zimbabwe',
    code: {
      a2: 'ZW',
      a3: 'ZWE',
    },
    shortList: 'x',
    houseNumber: false,
    state: false,
    parent: null,
    depType: null,
    stateTerm: null,
    currency: {
      code: 'ZWL',
      name: 'Zimbabwe Dollar',
      symbol: '$',
    },
    num: 716,
    dialingCode: 263,
    langs: [
      {
        name: 'English',
        code: 'en',
      },
      {
        name: 'Shona',
        code: 'sn',
      },
      {
        name: 'Ndebele',
        code: 'nd',
      },
    ],
    tz: [
      {
        name: 'Central Africa Time',
        code: 'CAT',
        gmtOffset: '+2',
      },
      {
        name: 'Central Africa Time',
        code: 'CAT',
        gmtOffset: '+2',
      },
    ],
    dst: false,
  },
]
